<template>
  <!--TEAM DETAILS-->
  <Modal v-if="popupTriggers.teamsInfoTrigger" :TogglePopup="() => TogglePopup('teamsInfoTrigger')">
    <div class="team-details">
      <header class="team-details-header">
        <h2>{{ team.name || team.teamName || 'Unnamed team' }}</h2>
        <p class="team-details-created">Created {{ team.created_date || formatCreatedDate(team.created) || '-' }}</p>
        <div class="team-details-actions">
          <button v-on:click="addMembers()" class="btn team-details-secondary">Add members</button>
          <button v-on:click="AddLicenses()" class="btn team-details-secondary">Activate licenses</button>
          <button v-on:click="changeTeam()" class="btn team-details-secondary">Team settings</button>
        </div>
      </header>

      <section class="team-details-section">
        <div class="team-details-section-heading"><h3>Team information</h3></div>
        <div class="team-details-summary">
          <div><span>Owner</span><strong>{{ team.ownerName || '-' }}</strong></div>
          <div><span>Owner number</span><strong>{{ team.phoneNumber || '-' }}</strong></div>
          <div><span>Contact</span><strong>{{ team.contactName || '-' }}</strong></div>
          <div><span>Contact email</span><strong>{{ team.contactEmail || '-' }}</strong></div>
          <div><span>Licenses</span><strong>{{ team.licenceCount ?? '-' }}</strong></div>
          <div><span>Hunt code</span><strong>{{ team.permanentHuntCode || '-' }}</strong></div>
          <div><span>License date</span><strong>{{ formatTeamSettingsDate(team.validDate || team.validUntil) }}</strong></div>
        </div>
      </section>

      <section class="team-details-section">
        <div class="team-details-section-heading">
          <h3>Members <span>({{ teamMemberRows.length }})</span></h3>
          <button v-on:click="downloadTeamMembersCsv()" class="btn team-details-secondary">Export CSV</button>
        </div>
        <div class="team-details-table-wrap">
        <table class="table table-hover team-details-table">
          <thead>
            <tr>
              <th class="bold">#</th>
              <th class="bold">Name</th>
              <th class="bold">Cellnumber</th>
              <th class="bold">Role<button v-on:click="togglePermissions()" class="btn"><svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" fill="currentColor" class="bi bi-pencil-fill" viewBox="0 0 16 16"><path d="M12.854.146a.5.5 0 0 0-.707 0L10.5 1.793 14.207 5.5l1.647-1.646a.5.5 0 0 0 0-.708l-3-3zm.646 6.061L9.793 2.5 3.293 9H3.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.207l6.5-6.5zm-7.468 7.468A.5.5 0 0 1 6 13.5V13h-.5a.5.5 0 0 1-.5-.5V12h-.5a.5.5 0 0 1-.5-.5V11h-.5a.5.5 0 0 1-.5-.5V11h-.5a.5.5 0 0 1-.5-.5V10h-.5a.499.499 0 0 0-.175-.032l-.179.178a.5.5 0 0 0-.11.168l-2 5a.5.5 0 0 0 .65.65l5-2a.5.5 0 0 0 .168-.11l.178-.178z" /></svg></button></th>
              <th class="bold">Team pays<button v-on:click="toggleFullMember()" class="btn"><svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" fill="currentColor" class="bi bi-pencil-fill" viewBox="0 0 16 16"><path d="M12.854.146a.5.5 0 0 0-.707 0L10.5 1.793 14.207 5.5l1.647-1.646a.5.5 0 0 0 0-.708l-3-3zm.646 6.061L9.793 2.5 3.293 9H3.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.207l6.5-6.5zm-7.468 7.468A.5.5 0 0 1 6 13.5V13h-.5a.5.5 0 0 1-.5-.5V12h-.5a.5.5 0 0 1-.5-.5V11h-.5a.5.5 0 0 1-.5-.5V11h-.5a.5.5 0 0 1-.5-.5V10h-.5a.499.499 0 0 0-.175-.032l-.179.178a.5.5 0 0 0-.11.168l-2 5a.5.5 0 0 0 .65.65l5-2a.5.5 0 0 0 .168-.11l.178-.178z" /></svg></button></th>
              <th class="bold">Paid by team</th>
              <th class="bold">License</th>
              <th class="bold">All Groups</th>
              <th class="bold">Last group</th>
              <th class="bold">Details</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(member, index) in teamMemberRows" :key="member.uuid || member.user.phoneNumber || index" :class="getTeamMemberRowClass(index)">
              <th>{{ index + 1 }}</th>
              <th v-if="member.user.name != null">
                {{ member.user.name }}
              </th>
              <th v-else></th>
              <th v-if="member.user.phoneNumber != null">
                {{ member.user.phoneNumber }}
              </th>
              <th v-else></th>
              <th v-if="member.permission != null">
                <div v-if="!togglepermissions">
                  {{ member.permission }}
                </div>
                <div v-else>
                  <div v-if="member.permission == 'owner'">
                    {{ member.permission }}
                  </div>
                  <div v-else>
                    {{ member.permission }}
                    <button class="btn" v-on:click="submitPermission(team, member)">
                      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrow-repeat" viewBox="0 0 16 16"><path d="M11.534 7h3.932a.25.25 0 0 1 .192.41l-1.966 2.36a.25.25 0 0 1-.384 0l-1.966-2.36a.25.25 0 0 1 .192-.41zm-11 2h3.932a.25.25 0 0 0 .192-.41L2.692 6.23a.25.25 0 0 0-.384 0L.342 8.59A.25.25 0 0 0 .534 9z"/><path fill-rule="evenodd" d="M8 3c-1.552 0-2.94.707-3.857 1.818a.5.5 0 1 1-.771-.636A6.002 6.002 0 0 1 13.917 7H12.9A5.002 5.002 0 0 0 8 3zM3.1 9a5.002 5.002 0 0 0 8.757 2.182.5.5 0 1 1 .771.636A6.002 6.002 0 0 1 2.083 9H3.1z"/></svg>
                    </button>
                  </div>
                </div>
              </th>
              <th v-else></th>
              <th>
                <div v-if="!togglefullmembers">
                  {{ member.fullMember }}
                </div>
                <div v-else>
                    {{ member.fullMember }}
                    <button class="btn" v-on:click="submitStatus(team, member)">
                      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrow-repeat" viewBox="0 0 16 16"><path d="M11.534 7h3.932a.25.25 0 0 1 .192.41l-1.966 2.36a.25.25 0 0 1-.384 0l-1.966-2.36a.25.25 0 0 1 .192-.41zm-11 2h3.932a.25.25 0 0 0 .192-.41L2.692 6.23a.25.25 0 0 0-.384 0L.342 8.59A.25.25 0 0 0 .534 9z" /><path fill-rule="evenodd" d="M8 3c-1.552 0-2.94.707-3.857 1.818a.5.5 0 1 1-.771-.636A6.002 6.002 0 0 1 13.917 7H12.9A5.002 5.002 0 0 0 8 3zM3.1 9a5.002 5.002 0 0 0 8.757 2.182.5.5 0 1 1 .771.636A6.002 6.002 0 0 1 2.083 9H3.1z" /></svg>
                    </button>
                </div>
              </th>
              <th><span :class="getPaidByTeamsClass(member)">{{ getPaidByTeamsDisplay(member) }}</span></th>
              <th v-if="member.userdata.last_license != null"><div v-if="member.userdata.last_license - 2629800000 > datenow"> {{ member.userdata.last_license_date }}</div><div v-else-if="member.userdata.last_license > datenow && member.userdata.last_license - 2629800000 < datenow" style="background-color: yellow">{{ member.userdata.last_license_date }}</div><div v-else style="background-color: red">{{ member.userdata.last_license_date }}</div></th>
              <th v-else></th>
              <th v-if="member.userdata.all_hunts != null">{{ member.userdata.all_hunts }}</th>
              <th v-else>0</th>
              <th>{{ getTeamMemberLastGroupDisplay(member) }}</th>
              <th><button type="button" class="btn team-details-user-button" title="Open user details" @click="userInfo(member)"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16" aria-hidden="true"><path d="M16 8s-3-5.5-8-5.5S0 8 0 8s3 5.5 8 5.5S16 8 16 8zm-8 3.5A3.5 3.5 0 1 1 8 4.5a3.5 3.5 0 0 1 0 7zm0-1A2.5 2.5 0 1 0 8 5.5a2.5 2.5 0 0 0 0 5z"/></svg></button></th>
              <th><div v-if="member.permission == 'owner'"></div><div v-else><button v-on:click="submitDeleteMember(team, member)" class="btn btn-sm"><svg xmlns="http://www.w3.org/2000/svg" style="margin-bottom: 5px" width="16" height="16" fill="currentColor" class="bi bi-trash" viewBox="0 0 16 16"><path d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6z"/><path fill-rule="evenodd" d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1v1zM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4H4.118zM2.5 3V2h11v1h-11z"/></svg></button></div></th>
            </tr>
          </tbody>
        </table>
        </div>
      </section>
      <table v-if="false">
        <thead>
          <tr>
            <th class="bold">Owner name</th>
            <th class="bold">Owner number</th>
            <th class="bold">Contact name</th>
            <th class="bold">Contact email</th>
            <th class="bold">Licenses amount</th>
            <th class="bold">Hunt code</th>
            <th class="bold">License date</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <th v-if="team.ownerName != null">{{ team.ownerName }}</th>
            <th v-else>-</th>
            <th v-if="team.phoneNumber != null">{{ team.phoneNumber }}</th>
            <th v-else>-</th>
            <th v-if="team.contactName != null">{{ team.contactName }}</th>
            <th v-else>-</th>
            <th v-if="team.contactEmail != null">{{ team.contactEmail }}</th>
            <th v-else>-</th>
            <th v-if="team.licenceCount != null">{{ team.licenceCount }}</th>
            <th v-else>-</th>
            <th v-if="team.permanentHuntCode != null">{{ team.permanentHuntCode }}</th>
            <th v-else>-</th>
            <th v-if="team.validDate != '' ">{{ team.validDate }}</th>
            <th v-else>-</th>
          </tr>
        </tbody>
      </table>
      <div v-if="false">
        <table class="table table-hover">
          <thead>
            <tr>
              <th class="bold">#</th>
              <th class="bold">Name</th>
              <th class="bold">Cellnumber</th>
              <th class="bold">Role<button v-on:click="togglePermissions()" class="btn"><svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" fill="currentColor" class="bi bi-pencil-fill" viewBox="0 0 16 16"><path d="M12.854.146a.5.5 0 0 0-.707 0L10.5 1.793 14.207 5.5l1.647-1.646a.5.5 0 0 0 0-.708l-3-3zm.646 6.061L9.793 2.5 3.293 9H3.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.207l6.5-6.5zm-7.468 7.468A.5.5 0 0 1 6 13.5V13h-.5a.5.5 0 0 1-.5-.5V12h-.5a.5.5 0 0 1-.5-.5V11h-.5a.5.5 0 0 1-.5-.5V10h-.5a.499.499 0 0 1-.175-.032l-.179.178a.5.5 0 0 0-.11.168l-2 5a.5.5 0 0 0 .65.65l5-2a.5.5 0 0 0 .168-.11l.178-.178z" /></svg></button></th>
              <th class="bold">Team pays<button v-on:click="toggleFullMember()" class="btn"><svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" fill="currentColor" class="bi bi-pencil-fill" viewBox="0 0 16 16"><path d="M12.854.146a.5.5 0 0 0-.707 0L10.5 1.793 14.207 5.5l1.647-1.646a.5.5 0 0 0 0-.708l-3-3zm.646 6.061L9.793 2.5 3.293 9H3.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.207l6.5-6.5zm-7.468 7.468A.5.5 0 0 1 6 13.5V13h-.5a.5.5 0 0 1-.5-.5V12h-.5a.5.5 0 0 1-.5-.5V11h-.5a.5.5 0 0 1-.5-.5V10h-.5a.499.499 0 0 1-.175-.032l-.179.178a.5.5 0 0 0-.11.168l-2 5a.5.5 0 0 0 .65.65l5-2a.5.5 0 0 0 .168-.11l.178-.178z" /></svg></button></th>
              <th class="bold">Paid by team</th>
              <th class="bold">License</th>
              <th class="bold">All Groups</th>
              <th class="bold">Details</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(member, index) in teamMemberRows" :key="member.uuid || member.user.phoneNumber || index" :class="getTeamMemberRowClass(index)">
              <th>{{ index + 1 }}</th>
              <th v-if="member.user.name != null">
                {{ member.user.name }}
              </th>
              <th v-else></th>
              <th v-if="member.user.phoneNumber != null">
                {{ member.user.phoneNumber }}
              </th>
              <th v-else></th>
              <th v-if="member.permission != null">
                <div v-if="!togglepermissions">
                  {{ member.permission }}
                </div>
                <div v-else>
                  <div v-if="member.permission == 'owner'">
                    {{ member.permission }}
                  </div>
                  <div v-else>
                    {{ member.permission }}
                    <button class="btn" v-on:click="submitPermission(team, member)">
                      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrow-repeat" viewBox="0 0 16 16"><path d="M11.534 7h3.932a.25.25 0 0 1 .192.41l-1.966 2.36a.25.25 0 0 1-.384 0l-1.966-2.36a.25.25 0 0 1 .192-.41zm-11 2h3.932a.25.25 0 0 0 .192-.41L2.692 6.23a.25.25 0 0 0-.384 0L.342 8.59A.25.25 0 0 0 .534 9z"/><path fill-rule="evenodd" d="M8 3c-1.552 0-2.94.707-3.857 1.818a.5.5 0 1 1-.771-.636A6.002 6.002 0 0 1 13.917 7H12.9A5.002 5.002 0 0 0 8 3zM3.1 9a5.002 5.002 0 0 0 8.757 2.182.5.5 0 1 1 .771.636A6.002 6.002 0 0 1 2.083 9H3.1z"/></svg>
                    </button>
                  </div>
                </div>
              </th>
              <th v-else></th>
              <th>
                <div v-if="!togglefullmembers">
                  {{ member.fullMember }}
                </div>
                <div v-else>
                    {{ member.fullMember }}
                    <button class="btn" v-on:click="submitStatus(team, member)">
                      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrow-repeat" viewBox="0 0 16 16"><path d="M11.534 7h3.932a.25.25 0 0 1 .192.41l-1.966 2.36a.25.25 0 0 1-.384 0l-1.966-2.36a.25.25 0 0 1 .192-.41zm-11 2h3.932a.25.25 0 0 0 .192-.41L2.692 6.23a.25.25 0 0 0-.384 0L.342 8.59A.25.25 0 0 0 .534 9z" /><path fill-rule="evenodd" d="M8 3c-1.552 0-2.94.707-3.857 1.818a.5.5 0 1 1-.771-.636A6.002 6.002 0 0 1 13.917 7H12.9A5.002 5.002 0 0 0 8 3zM3.1 9a5.002 5.002 0 0 0 8.757 2.182.5.5 0 1 1 .771.636A6.002 6.002 0 0 1 2.083 9H3.1z" /></svg>
                    </button>
                </div>
              </th>
              <th>
                <span :class="getPaidByTeamsClass(member)">{{ getPaidByTeamsDisplay(member) }}</span>
              </th>

              <th v-if="member.userdata.last_license != null">
                <div v-if="member.userdata.last_license - 2629800000 > datenow"> {{ member.userdata.last_license_date }}</div>
                <div v-else-if="member.userdata.last_license > datenow && member.userdata.last_license - 2629800000 < datenow" style="background-color: yellow">{{ member.userdata.last_license_date }}</div>
                <div v-else style="background-color: red">{{ member.userdata.last_license_date }}</div>
              </th>
              <th v-else></th>

              <th v-if="member.userdata.all_hunts != null">
                {{ member.userdata.all_hunts }}
              </th>
              <th v-else>0</th>

              <th>
                <svg v-on:click="userInfo(member)" xmlns="http://www.w3.org/2000/svg" width="14" height="14" fill="currentColor" class="bi bi-info-circle" viewBox="0 0 16 16"><path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z" /><path d="m8.93 6.588-2.29.287-.082.38.45.083c.294.07.352.176.288.469l-.738 3.468c-.194.897.105 1.319.808 1.319.545 0 1.178-.252 1.465-.598l.088-.416c-.2.176-.492.246-.686.246-.275 0-.375-.193-.304-.533L8.93 6.588zM9 4.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0z"/></svg>
              </th>

              <th>
                <div v-if="member.permission == 'owner'"></div>
                <div v-else>
                  <button v-on:click="submitDeleteMember(team, member)" class="btn btn-sm">
                    <svg xmlns="http://www.w3.org/2000/svg" style="margin-bottom: 5px" width="16" height="16" fill="currentColor" class="bi bi-trash" viewBox="0 0 16 16"><path d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0V6z"/><path fill-rule="evenodd" d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1v1zM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4H4.118zM2.5 3V2h11v1h-11z"/></svg>
                  </button>
                </div>
              </th>
            </tr>
          </tbody>
        </table>
        <div class="d-flex justify-content-end mt-2">
          <button v-on:click="downloadTeamMembersCsv()" class="btn btn-sm btn-outline-dark btn-rounded">Export CSV</button>
        </div>
      </div>

      <section class="team-details-section">
        <div class="team-details-section-heading"><h3>Team SIMs <span>({{ activeLinkedTeamSims.length }})</span></h3></div>
        <div class="team-details-table-wrap">
        <table class="table table-hover team-details-table">
          <thead>
            <tr>
              <th class="bold">#</th>
              <th class="bold">Number</th>
              <th class="bold">IMEI</th>
              <th class="bold">Valid Until</th>
              <th class="bold">Status</th>
              <th class="bold">Brand</th>
              <th class="bold">Notes</th>
              <th class="bold">Details</th>
            </tr>
          </thead>
          <tbody v-if="activeLinkedTeamSims.length > 0">
            <tr v-for="(sim, index) in activeLinkedTeamSims" :key="sim.id || sim.phoneNumber || index">
              <th>{{ index + 1 }}</th>
              <th>{{ sim.phoneNumber || "-" }}</th>
              <th>{{ sim.imei || "-" }}</th>
              <th><span :class="getLinkedTeamSimValidUntilClass(sim)">{{ getTeamSimValidUntilDisplay(sim) }}</span></th>
              <th><span :class="getLinkedTeamSimStatusClass(sim)">{{ sim.status || "-" }}</span></th>
              <th><span :class="getLinkedTeamSimBrandClass(sim.brand)">{{ sim.brand || "-" }}</span></th>
              <th>{{ sim.notes || "-" }}</th>
              <th><button type="button" class="btn team-details-sim-button" title="Open SIM details" aria-label="Open SIM details" @click="openSimDetails(sim)"><svg xmlns="http://www.w3.org/2000/svg" width="11" height="11" fill="currentColor" class="bi bi-info-lg" viewBox="0 0 16 16" aria-hidden="true"><path d="M8 0a8 8 0 1 0 0 16A8 8 0 0 0 8 0zm0 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14z"/><path d="m8.93 6.588-2.29.287-.082.38.45.083c.294.07.352.176.288.469l-.738 3.468c-.194.897.105 1.319.808 1.319.545 0 1.178-.252 1.465-.598l.088-.416c-.2.176-.492.246-.686.246-.275 0-.375-.193-.304-.533L8.93 6.588z"/><circle cx="8" cy="4.5" r="1"/></svg></button></th>
            </tr>
          </tbody>
          <tbody v-else>
            <tr>
              <th colspan="8">No SIMs linked to this team.</th>
            </tr>
          </tbody>
        </table>
        </div>
      </section>

      <section v-if="inactiveLinkedTeamSims.length > 0" class="team-details-section team-details-inactive-sims">
        <div class="team-details-section-heading"><h3>Stopped / closed SIMs <span>({{ inactiveLinkedTeamSims.length }})</span></h3></div>
        <p class="team-details-section-note">These devices are no longer operating and are excluded from license renewal.</p>
        <div class="team-details-table-wrap">
        <table class="table table-hover team-details-table">
          <thead>
            <tr>
              <th class="bold">#</th>
              <th class="bold">Number</th>
              <th class="bold">IMEI</th>
              <th class="bold">Valid Until</th>
              <th class="bold">Status</th>
              <th class="bold">Brand</th>
              <th class="bold">Notes</th>
              <th class="bold">Details</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(sim, index) in inactiveLinkedTeamSims" :key="`inactive-${sim.id || sim.phoneNumber || index}`">
              <th>{{ index + 1 }}</th>
              <th>{{ sim.phoneNumber || "-" }}</th>
              <th>{{ sim.imei || "-" }}</th>
              <th><span :class="getLinkedTeamSimValidUntilClass(sim)">{{ getTeamSimValidUntilDisplay(sim) }}</span></th>
              <th><span :class="getLinkedTeamSimStatusClass(sim)">{{ sim.status || "-" }}</span></th>
              <th><span :class="getLinkedTeamSimBrandClass(sim.brand)">{{ sim.brand || "-" }}</span></th>
              <th>{{ sim.notes || "-" }}</th>
              <th><button type="button" class="btn team-details-sim-button" title="Open SIM details" aria-label="Open SIM details" @click="openSimDetails(sim)"><svg xmlns="http://www.w3.org/2000/svg" width="11" height="11" fill="currentColor" class="bi bi-info-lg" viewBox="0 0 16 16" aria-hidden="true"><path d="M8 0a8 8 0 1 0 0 16A8 8 0 0 0 8 0zm0 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14z"/><path d="m8.93 6.588-2.29.287-.082.38.45.083c.294.07.352.176.288.469l-.738 3.468c-.194.897.105 1.319.808 1.319.545 0 1.178-.252 1.465-.598l.088-.416c-.2.176-.492.246-.686.246-.275 0-.375-.193-.304-.533L8.93 6.588z"/><circle cx="8" cy="4.5" r="1"/></svg></button></th>
            </tr>
          </tbody>
        </table>
        </div>
      </section>
    </div>
  </Modal>

  <SimDetailsModal
    :visible="popupTriggers.simDetailsTrigger"
    :sim="selectedTeamSim"
    :team-display="team.name || team.teamName || ''"
    :toggle-popup="() => TogglePopup('simDetailsTrigger')"
    @open-user="openSimUserDetails"
    @open-team="popupTriggers.simDetailsTrigger = false"
  />

  <!--USER DETAILS-->
  <UserDetailsModal
    :visible="popupTriggers.userInfoTrigger"
    :user="user.userdata"
    :toggle-popup="() => TogglePopup('userInfoTrigger')"
  />

  <Modal v-if="false" :TogglePopup="() => TogglePopup('userInfoTrigger')">
    <div>
      <p style="font-weight: bold; font-size: 14px">General Info</p>
      <table class="table table-hover">
        <thead>
          <tr>
            <th class="bold">Name</th>
            <th class="bold">Cellnumber</th>
            <th class="bold">Email</th>
            <th class="bold">Created</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <th>{{ user.userdata.name }}</th>
            <th>{{ user.userdata.cellnumber }}</th>
            <th>{{ user.userdata.email }}</th>
            <th>{{ user.userdata.created_date }}</th>
          </tr>
        </tbody>
      </table>

      <p style="font-weight: bold; font-size: 14px">Teams Info</p>
      <table class="table table-hover">
        <thead>
          <tr>
            <th class="bold">Team name</th>
            <th class="bold">Role</th>
            <th class="bold">Team owner</th>
            <th class="bold">Team owner number</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="user in user.userdata.teamsinfo" :key="user">
            <th>{{ user.teamName }}</th>
            <th>{{ user.teamRole }}</th>
            <th>{{ user.teamOwner }}</th>
            <th>{{ user.teamOwnerNumber }}</th>
          </tr>
        </tbody>
      </table>

      <p style="font-weight: bold; font-size: 14px">Group Info</p>
      <table class="table table-hover">
        <thead>
          <tr>
            <th class="bold">Group</th>
            <th class="bold">Info</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <th class="bold">Groups created</th>
            <th scope="row">
              {{ user.userdata.created_hunts }}
            </th>
          </tr>
          <tr>
            <th class="bold">Groups joined</th>
            <th scope="row">
              {{ user.userdata.all_hunts }}
            </th>
          </tr>
          <tr>
            <th class="bold">Last group</th>
            <th scope="row">
              <div v-if="user.userdata.last_joined_date == ''">None</div>
              <div v-else>
                {{ user.userdata.last_joined_date }}
              </div>
            </th>
          </tr>
        </tbody>
      </table>

      <div class="d-flex justify-content-between">
        <p style="font-weight: bold; font-size: 14px">Licenses</p>
        <button class="btn btn-outline-dark btn-rounded" v-on:click="toggleUserLicense()">Add License</button>
      </div>
      
      <div v-if="togglenewlicense">
        <p style="font-size: 10px; margin-bottom: -2px">Date</p>
        <input v-model="userLicenseDate" type="date" class="form-control" style="width:60%" />
        <p style="font-size: 10px; margin-bottom: -2px">Comment</p>
        <input id="newLicenseComment" type="text" class="form-control" style="width:60%" />
        <button v-on:click="submitSingleLicense(user)" class="btn btn-outline-dark btn-rounded mt-2">Add License</button>
      </div>
      
      <table class="table table-hover">
        <thead>
          <tr>
            <th class="bold">#</th>
            <th class="bold">Comment</th>
            <th class="bold">Creator</th>
            <th class="bold">Product</th>
            <th class="bold">Created</th>
            <th class="bold">Valid until</th>
          </tr>
        </thead>
        <tbody v-if="!togglelicenses && user.userdata.licenses != null">
          <tr>
            <th>1</th>
            <th>{{ user.userdata.licenses[0].comment }}</th>
            <th>{{ user.userdata.licenses[0].creator }}</th>
            <th>{{ user.userdata.licenses[0].product }}</th>
            <th>{{ new Date(user.userdata.licenses[0].created).getFullYear() }}-{{("0" + (new Date(user.userdata.licenses[0].created).getMonth() + 1)).slice(-2)}}-{{("0" + new Date(user.userdata.licenses[0].created).getDate()).slice(-2)}}</th>
            <th>{{ new Date(user.userdata.licenses[0].validuntil).getFullYear() }}-{{("0" + (new Date(user.userdata.licenses[0].validuntil).getMonth() + 1)).slice(-2)}}-{{("0" + new Date(user.userdata.licenses[0].validuntil).getDate()).slice(-2)}}</th>
          </tr>
        </tbody>
        <tbody v-else-if="togglelicenses">
          <tr v-for="(user, index) in user.userdata.licenses" :key="user">
            <th scope="row">{{ index + 1 }}</th>
            <th scope="row">{{ user.comment }}</th>
            <th scope="row">{{ user.creator }}</th>
            <th scope="row">{{ user.product }}</th>
            <th scope="row">{{ new Date(user.created).getFullYear() }}-{{("0" + (new Date(user.created).getMonth() + 1)).slice(-2)}}-{{ ("0" + new Date(user.created).getDate()).slice(-2) }}</th>
            <th scope="row">{{ new Date(user.validuntil).getFullYear() }}-{{("0" + (new Date(user.validuntil).getMonth() + 1)).slice(-2)}}-{{ ("0" + new Date(user.validuntil).getDate()).slice(-2) }}</th>
          </tr>
        </tbody>
      </table>

      <div class="row justify-content-center" v-if="!togglelicenses">
        <svg v-on:click="toggleLicenses()" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrows-expand" viewBox="0 0 16 16"><path fill-rule="evenodd" d="M1 8a.5.5 0 0 1 .5-.5h13a.5.5 0 0 1 0 1h-13A.5.5 0 0 1 1 8zM7.646.146a.5.5 0 0 1 .708 0l2 2a.5.5 0 0 1-.708.708L8.5 1.707V5.5a.5.5 0 0 1-1 0V1.707L6.354 2.854a.5.5 0 1 1-.708-.708l2-2zM8 10a.5.5 0 0 1 .5.5v3.793l1.146-1.147a.5.5 0 0 1 .708.708l-2 2a.5.5 0 0 1-.708 0l-2-2a.5.5 0 0 1 .708-.708L7.5 14.293V10.5A.5.5 0 0 1 8 10z" /></svg>
      </div>
      <div class="row justify-content-center" v-else-if="togglelicenses">
        <svg v-on:click="toggleLicenses()" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrows-collapse" viewBox="0 0 16 16"><path fill-rule="evenodd" d="M1 8a.5.5 0 0 1 .5-.5h13a.5.5 0 0 1 0 1h-13A.5.5 0 0 1 1 8zm7-8a.5.5 0 0 1 .5.5v3.793l1.146-1.147a.5.5 0 0 1 .708.708l-2 2a.5.5 0 0 1-.708 0l-2-2a.5.5 0 1 1 .708-.708L7.5 4.293V.5A.5.5 0 0 1 8 0zm-.5 11.707-1.146 1.147a.5.5 0 0 1-.708-.708l2-2a.5.5 0 0 1 .708 0l2 2a.5.5 0 0 1-.708.708L8.5 11.707V15.5a.5.5 0 0 1-1 0v-3.793z" /></svg>
      </div>


      <p style="font-weight: bold; font-size: 14px">Devices</p>
      <table class="table table-hover">
        <thead>
          <tr>
            <th class="bold">#</th>
            <th class="bold">App Language</th>
            <th class="bold">App Version</th>
            <th class="bold">Created</th>
            <th class="bold">Email</th>
            <th class="bold">Manufacturer</th>
            <th class="bold">Model</th>
            <th class="bold">Name</th>
            <th class="bold">OS</th>
            <th class="bold">OS Version</th>
          </tr>
        </thead>
        <tbody v-if="!toggledevices && user.userdata.devices != null">
          <tr>
            <th>1</th>
            <th>{{ user.userdata.devices[0].applanguage }}</th>
            <th>{{ user.userdata.devices[0].appversion }}</th>
            <th>{{ new Date(user.userdata.devices[0].created).getFullYear() }}-{{("0" + (new Date(user.userdata.devices[0].created).getMonth() + 1)).slice(-2)}}-{{("0" + new Date(user.userdata.devices[0].created).getDate()).slice(-2)}}</th>
            <th>{{ user.userdata.devices[0].email }}</th>
            <th>{{ user.userdata.devices[0].manufacturer }}</th>
            <th>{{ user.userdata.devices[0].model }}</th>
            <th>{{ user.userdata.devices[0].name }}</th>
            <th>{{ user.userdata.devices[0].opsys }}</th>
            <th>{{ user.userdata.devices[0].opsysversion }}</th>
          </tr>
        </tbody>
        <tbody v-else-if="toggledevices">
          <tr v-for="(user, index) in user.userdata.devices" :key="user">
            <th scope="row">{{ index + 1 }}</th>
            <th scope="row">{{ user.applanguage }}</th>
            <th scope="row">{{ user.appversion }}</th>
            <th scope="row">{{ new Date(user.created).getFullYear() }}-{{("0" + (new Date(user.created).getMonth() + 1)).slice(-2)}}-{{("0" + new Date(user.created).getDate()).slice(-2)}}</th>
            <th scope="row">{{ user.email }}</th>
            <th scope="row">{{ user.manufacturer }}</th>
            <th scope="row">{{ user.model }}</th>
            <th scope="row">{{ user.name }}</th>
            <th scope="row">{{ user.opsys }}</th>
            <th scope="row">{{ user.opsysversion }}</th>
          </tr>
        </tbody>
      </table>

      <div class="row justify-content-center" v-if="!toggledevices">
        <svg v-on:click="toggleDevices()" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrows-expand" viewBox="0 0 16 16"><path fill-rule="evenodd" d="M1 8a.5.5 0 0 1 .5-.5h13a.5.5 0 0 1 0 1h-13A.5.5 0 0 1 1 8zM7.646.146a.5.5 0 0 1 .708 0l2 2a.5.5 0 0 1-.708.708L8.5 1.707V5.5a.5.5 0 0 1-1 0V1.707L6.354 2.854a.5.5 0 1 1-.708-.708l2-2zM8 10a.5.5 0 0 1 .5.5v3.793l1.146-1.147a.5.5 0 0 1 .708.708l-2 2a.5.5 0 0 1-.708 0l-2-2a.5.5 0 0 1 .708-.708L7.5 14.293V10.5A.5.5 0 0 1 8 10z" /></svg>
      </div>
      <div class="row justify-content-center" v-else-if="toggledevices">
        <svg v-on:click="toggleDevices()" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrows-collapse" viewBox="0 0 16 16"><path fill-rule="evenodd" d="M1 8a.5.5 0 0 1 .5-.5h13a.5.5 0 0 1 0 1h-13A.5.5 0 0 1 1 8zm7-8a.5.5 0 0 1 .5.5v3.793l1.146-1.147a.5.5 0 0 1 .708.708l-2 2a.5.5 0 0 1-.708 0l-2-2a.5.5 0 1 1 .708-.708L7.5 4.293V.5A.5.5 0 0 1 8 0zm-.5 11.707-1.146 1.147a.5.5 0 0 1-.708-.708l2-2a.5.5 0 0 1 .708 0l2 2a.5.5 0 0 1-.708.708L8.5 11.707V15.5a.5.5 0 0 1-1 0v-3.793z" /></svg>
      </div>

      <p style="font-weight: bold; font-size: 14px">Notes</p>
      <table class="table table-hover">
        <thead>
          <tr>
            <th class="bold">#</th>
            <th class="bold">Created</th>
            <th class="bold">Comment</th>
          </tr>
        </thead>
        <tbody v-if="!togglenotes && user.userdata.notes.length != 0">
          <tr>
            <th>1</th>
            <th>{{ new Date(user.userdata.notes[0].created).getFullYear() }}-{{("0" + (new Date(user.userdata.notes[0].created).getMonth() + 1)).slice(-2)}}-{{("0" + new Date(user.userdata.notes[0].created).getDate()).slice(-2)}}</th>
            <th v-if="user.userdata.notes[0].data.text != null">{{ user.userdata.notes[0].data.text }}</th>
            <th scope="row" v-else-if="user.userdata.notes[0].data.text == null && user.userdata.notes[0].name == 'huntloc_login'">Huntloc Login</th>
            <th scope="row" v-else-if="user.userdata.notes[0].data.text == null && user.userdata.notes[0].name == 'liveteam_login'">Liveteam Login</th>
            <th scope="row" v-else></th>
          </tr>
        </tbody>
        <tbody v-else-if="togglenotes">
          <tr v-for="(notes, index) in user.userdata.notes" :key="notes">
            <th scope="row">{{ index + 1 }}</th>
            <th>{{ new Date(notes.created).getFullYear() }}-{{("0" + (new Date(notes.created).getMonth() + 1)).slice(-2)}}-{{("0" + new Date(notes.created).getDate()).slice(-2)}}</th>
            <th scope="row" v-if="notes.data.text != null">{{ notes.data.text }}</th>
            <th scope="row" v-else-if="notes.data.text == null && notes.name == 'huntloc_login'">Huntloc Login</th>
            <th scope="row" v-else-if="notes.data.text == null && notes.name == 'liveteam_login'">Liveteam Login</th>
            <th scope="row" v-else></th>
          </tr>
        </tbody>
      </table>

      <div class="row justify-content-center" v-if="!togglenotes">
        <svg v-on:click="toggleNotes()" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrows-expand" viewBox="0 0 16 16"><path fill-rule="evenodd" d="M1 8a.5.5 0 0 1 .5-.5h13a.5.5 0 0 1 0 1h-13A.5.5 0 0 1 1 8zM7.646.146a.5.5 0 0 1 .708 0l2 2a.5.5 0 0 1-.708.708L8.5 1.707V5.5a.5.5 0 0 1-1 0V1.707L6.354 2.854a.5.5 0 1 1-.708-.708l2-2zM8 10a.5.5 0 0 1 .5.5v3.793l1.146-1.147a.5.5 0 0 1 .708.708l-2 2a.5.5 0 0 1-.708 0l-2-2a.5.5 0 0 1 .708-.708L7.5 14.293V10.5A.5.5 0 0 1 8 10z" /></svg>
      </div>
      <div class="row justify-content-center" v-else-if="togglenotes">
        <svg v-on:click="toggleNotes()" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrows-collapse" viewBox="0 0 16 16"><path fill-rule="evenodd" d="M1 8a.5.5 0 0 1 .5-.5h13a.5.5 0 0 1 0 1h-13A.5.5 0 0 1 1 8zm7-8a.5.5 0 0 1 .5.5v3.793l1.146-1.147a.5.5 0 0 1 .708.708l-2 2a.5.5 0 0 1-.708 0l-2-2a.5.5 0 1 1 .708-.708L7.5 4.293V.5A.5.5 0 0 1 8 0zm-.5 11.707-1.146 1.147a.5.5 0 0 1-.708-.708l2-2a.5.5 0 0 1 .708 0l2 2a.5.5 0 0 1-.708.708L8.5 11.707V15.5a.5.5 0 0 1-1 0v-3.793z" /></svg>
      </div>

      <p style="font-weight: bold; font-size: 14px">Add note</p>
      <textarea id="userNoteInput" style="height: 100px" class="form-control" />
      <button type="button" class="btn btn-outline-dark btn-rounded" data-mdb-ripple-color="dark" v-on:click="addNotes(user)">Add Note</button>

      <div class="justify-content-between d-flex"><span><p style="font-weight: bold; font-size: 14px">Portal Authentication</p></span><span><button class="btn btn-outline-dark btn-rounded" v-on:click="toPortal()">Portal</button></span></div>
      <input type="text" class="form-control" placeholder="" v-model="portalPIN"/>
      <button type="button" class="btn btn-outline-dark btn-rounded" data-mdb-ripple-color="dark" v-on:click="loginPortal(user)">Login</button>
    </div>
  </Modal>

  <!--NEW TEAM-->
  <Modal v-if="popupTriggers.addNewTeamTrigger" :TogglePopup="() => TogglePopup('addNewTeamTrigger')">
    <div style="width: 400px">
      <h5>Create Team</h5>
      <p>Owner number</p>
      <input id="teamOwnerInput" class="search form-control form-control-sm mb-2" type="text" placeholder="Cellnumber" />
      <p>Team name</p>
      <input id="teamNameInput" class="search form-control form-control-sm mb-2" type="text" placeholder="Name" />
      <button v-on:click="submitNewTeam()" class="btn btn-sm btn-outline-dark btn-rounded">
        Create team
      </button>
    </div>
  </Modal>

  <!--TEAM SETTINGS-->
  <Modal v-if="popupTriggers.changeTeamTrigger" :TogglePopup="() => TogglePopup('changeTeamTrigger')">
    <div class="team-settings">
      <header class="team-settings-header">
        <p class="team-settings-eyebrow">Team administration</p>
        <h5>Team settings</h5>
        <p>Update the team’s details and licensing.</p>
      </header>

      <div class="team-settings-card">
        <div class="team-settings-card-header"><label for="newTeamNameInput">Team name</label><span>{{ team.name || team.teamName || 'Not set' }}</span></div>
        <div class="team-settings-control-row"><input id="newTeamNameInput" class="form-control" placeholder="Enter a new team name"/><button v-on:click="submitNewTeamName(team)" class="btn team-settings-save">Save</button></div>
      </div>
      <div class="team-settings-card">
        <div class="team-settings-card-header"><label for="newContactNameInput">Contact name</label><span>{{ team.contactName || 'Not set' }}</span></div>
        <div class="team-settings-control-row"><input id="newContactNameInput" class="form-control" placeholder="Enter a contact name"/><button v-on:click="submitNewContactName(team)" class="btn team-settings-save">Save</button></div>
      </div>
      <div class="team-settings-card">
        <div class="team-settings-card-header"><label for="newContactEmailInput">Contact email</label><span>{{ team.contactEmail || 'Not set' }}</span></div>
        <div class="team-settings-control-row"><input id="newContactEmailInput" class="form-control" placeholder="Enter a contact email"/><button v-on:click="submitNewContactEmail(team)" class="btn team-settings-save">Save</button></div>
      </div>
      <div class="team-settings-card">
        <div class="team-settings-card-header"><label for="newLicenseAmountInput">Licenses</label><span>{{ team.licenceCount ?? 'Not set' }}</span></div>
        <div class="team-settings-control-row"><input id="newLicenseAmountInput" class="form-control" placeholder="Enter license amount"/><button v-on:click="submitNewLicenseAmount(team)" class="btn team-settings-save">Save</button></div>
      </div>
      <div class="team-settings-card">
        <div class="team-settings-card-header"><label for="teamLicenseDate">License date</label><span>{{ formatTeamSettingsDate(team.validDate || team.validUntil) }}</span></div>
        <div class="team-settings-control-row"><input id="teamLicenseDate" v-model="teamLicenseDate" type="date" class="form-control" /><button v-on:click="submitNewLicenseDate(team)" class="btn team-settings-save">Save</button></div>
      </div>
      <div class="team-settings-card">
        <div class="team-settings-card-header"><label for="newHuntCodeInput">Hunt code</label><span>{{ team.permanentHuntCode || 'Not set' }}</span></div>
        <div class="team-settings-control-row team-settings-hunt-code"><input v-model="teamHuntCodeInput" id="newHuntCodeInput" class="form-control" placeholder="Enter hunt code"/><button v-on:click="submitNewHuntCode(team)" :disabled="isGeneratingHuntCode" class="btn team-settings-save">Save</button><button v-on:click="generateAndSaveHuntCode(team)" :disabled="isGeneratingHuntCode" class="btn team-settings-generate">{{ isGeneratingHuntCode ? "Generating..." : "Generate" }}</button></div>
        <p class="team-settings-hint">Generate uses the current team name and saves the code automatically.</p>
      </div>

      <section class="team-settings-danger">
        <div><h6>Delete team</h6><p>This permanently deletes the team and its memberships.</p></div>
        <button v-on:click="submitDeleteTeam(team)" class="btn team-settings-delete-button">Delete</button>
      </section>
    </div>
  </Modal>


  <!--ADD MEMBERS-->
  <Modal
    v-if="popupTriggers.addMembersTrigger"
    :TogglePopup="() => TogglePopup('addMembersTrigger')"
  >
    <div class="team-members-dialog">
      <header class="team-members-header">
        <h2>Add members</h2>
        <p>{{ team.name || team.teamName || 'Unnamed team' }}</p>
      </header>

      <section class="team-details-section team-members-input-section">
        <div class="team-details-section-heading"><h3>Phone numbers</h3></div>
        <p class="team-members-help">Enter one phone number per line. Members are added with the <strong>view</strong> role and team-paid status.</p>
        <p class="team-members-help">Only digits and an optional + at the beginning are allowed. Spaces and other copied characters are removed automatically.</p>
        <textarea
          :value="newMembersInput"
          @input="updateNewMembersInput"
          id="newMemberInput"
          class="form-control team-members-input"
          placeholder="+37251234567"
          :disabled="newMembersSubmitting"
        ></textarea>
        <div class="team-members-actions">
        <button
          v-on:click="prepareNewMembers()"
          class="btn team-members-check"
          :disabled="newMembersSubmitting"
        >
          Check members
        </button>
        <button
          v-if="newMembersChecked"
          v-on:click="resetNewMembersPreview()"
          class="btn team-members-edit"
          :disabled="newMembersSubmitting"
        >
          Edit list
        </button>
      </div>
      </section>

      <section v-if="newMembersChecked" class="team-details-section">
        <div class="team-details-section-heading"><h3>Existing users <span>({{ existingNewMembersPreview.length }})</span></h3></div>
        <div v-if="existingNewMembersPreview.length > 0" class="team-details-table-wrap">
        <table class="table table-hover team-details-table team-members-table">
          <thead>
            <tr>
              <th>#</th>
              <th>Name</th>
              <th>Cellnumber</th>
              <th>License valid until</th>
              <th>Status</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(member, index) in existingNewMembersPreview" :key="`existing-${member.phoneNumber}`">
              <th>{{ index + 1 }}</th>
              <th>{{ member.displayName || "-" }}</th>
              <th>{{ member.phoneNumber }}</th>
              <th>{{ member.licenseDate || "-" }}</th>
              <th>
                <span :class="getNewMemberStatusClass(member)">{{ getNewMemberStatusDisplay(member) }}</span>
              </th>
            </tr>
          </tbody>
        </table>
        </div>
        <p v-else class="team-members-empty">No existing users found.</p>

        <div class="team-details-section-heading team-members-new-heading"><h3>New members <span>({{ newOnlyMembersPreview.length }})</span></h3></div>

        <p v-if="newOnlyMembersPreview.length > 0" class="team-members-help">
          These phone numbers were not found in the user database preview. They will be added with the phone number only.
        </p>
        <div v-if="newOnlyMembersPreview.length > 0" class="team-details-table-wrap">
        <table class="table table-hover team-details-table team-members-table">
          <thead>
            <tr>
              <th>#</th>
              <th>Name</th>
              <th>Cellnumber</th>
              <th>License valid until</th>
              <th>Status</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(member, index) in newOnlyMembersPreview" :key="`new-${member.phoneNumber}`">
              <th>{{ existingNewMembersPreview.length + index + 1 }}</th>
              <th>-</th>
              <th>{{ member.phoneNumber }}</th>
              <th>-</th>
              <th><span :class="getNewMemberStatusClass(member)">{{ getNewMemberStatusDisplay(member) }}</span></th>
            </tr>
          </tbody>
        </table>
        </div>
        <p v-else class="team-members-empty">No new members found.</p>

        <div class="team-members-submit-row">
          <button
            v-on:click="submitPreparedMembers(team)"
            class="btn team-members-submit"
            :disabled="newMembersSubmitting || submittableNewMembersPreview.length === 0"
          >
            Add selected members
          </button>
        </div>
      </section>
    </div>
  </Modal>

  <!--ADD LICENSE-->
  <Modal v-if="popupTriggers.activateLicenseTrigger" :TogglePopup="() => TogglePopup('activateLicenseTrigger')">
    <div class="team-license-dialog">
      <header class="team-license-header">
        <h2>Activate licenses</h2>
        <p>{{ team.name || team.teamName || 'Unnamed team' }}</p>
      </header>

      <section class="team-details-section team-license-controls">
        <div class="team-details-summary">
          <div><span>License date</span><strong>{{ formatTeamSettingsDate(team.validDate || team.validUntil) }}</strong></div>
          <div><span>Available licenses</span><strong>{{ team.licenceCount ?? 0 }}</strong></div>
        </div>
        <p class="team-license-safety-note">A license is added only when the team license date is later than the member's longest existing license.</p>
        <label class="team-license-comment-label" for="licenseCommentInput">Comment</label>
        <input id="licenseCommentInput" v-model="teamLicenseComment" class="form-control team-license-comment" type="text" placeholder="Add a comment">
        <div class="team-license-actions">
          <div class="team-license-choice-buttons">
            <button v-on:click="toggleAddChoice('all')" :class="getAddChoiceButtonClass('all')">All team-paid</button>
            <button v-on:click="toggleAddChoice('needed')" :class="getAddChoiceButtonClass('needed')">Needs renewal</button>
            <button v-on:click="toggleAddChoice('custom')" :class="getAddChoiceButtonClass('custom')">Custom selection</button>
          </div>
          <button v-on:click="activateTeamLicense(team)" class="btn team-license-submit">Activate licenses</button>
        </div>
      </section>

      <section class="team-details-section">
        <div class="team-details-section-heading">
          <h3>Members <span>({{ teamLicenseMemberRows.length }})</span></h3>
          <div class="team-license-legend">
            <span><i class="team-license-status expired"></i>Expired</span>
            <span><i class="team-license-status expiring"></i>Expires soon</span>
            <span><i class="team-license-status behind"></i>Before team date</span>
          </div>
        </div>
        <div class="team-details-table-wrap">
          <table class="table table-hover team-details-table">
            <thead>
              <tr>
                <th>#</th>
                <th>Name</th>
                <th>Cellnumber</th>
                <th>License</th>
                <th>Renewal</th>
                <th v-if="addlicenseschoice === 'custom'">Team pays</th>
                <th v-if="addlicenseschoice === 'custom'">Select</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(member, index) in teamLicenseMemberRows" :key="member.uuid || member.user.phoneNumber || index">
                <th>{{ index + 1 }}</th>
                <th>{{ member.user.name }}</th>
                <th>{{ member.user.phoneNumber }}</th>
                <th><span :class="getTeamLicenseCellClass(member)">{{ getTeamLicenseCellDisplay(member) }}</span></th>
                <th><span :class="getTeamLicenseEligibilityClass(member)">{{ getTeamLicenseEligibilityDisplay(member) }}</span></th>
                <th v-if="addlicenseschoice === 'custom'">{{ member.fullMember ? 'Yes' : 'No' }}</th>
                <th v-if="addlicenseschoice === 'custom'"><input class="checkbox" type="checkbox" :checked="isCustomMemberSelected(member)" :disabled="!memberNeedsTeamLicense(member)" :title="memberNeedsTeamLicense(member) ? '' : 'Existing license is valid for the same date or longer'" @change="toggleCustomMemberSelection(member, $event.target.checked)"></th>
              </tr>
            </tbody>
          </table>
        </div>
      </section>

      <section class="team-details-section">
        <div class="team-details-section-heading"><h3>Linked SIMs to renew <span>({{ teamLicenseSimRows.length }})</span></h3></div>
        <div class="team-details-table-wrap">
          <table class="table table-hover team-details-table">
          <thead>
            <tr>
              <th>#</th>
              <th>SIM</th>
              <th>IMEI</th>
              <th>Valid Until</th>
              <th>Status</th>
              <th>Extension (years)</th>
            </tr>
          </thead>
          <tbody v-if="teamLicenseSimRows.length > 0">
            <tr v-for="(sim, index) in teamLicenseSimRows" :key="`license-sim-${sim.id || sim.phoneNumber || index}`">
              <th>{{ index + 1 }}</th>
              <th>{{ sim.phoneNumber || "-" }}</th>
              <th>{{ sim.imei || "-" }}</th>
              <th>
                <div :class="getTeamSimLicenseCellClass(sim)">{{ getTeamSimValidUntilDisplay(sim) }}</div>
              </th>
              <th><span :class="getLinkedTeamSimStatusClass(sim)">{{ sim.status || "-" }}</span></th>
              <th>{{ getTeamSimExtensionYearsDisplay(sim) }}</th>
            </tr>
          </tbody>
          <tbody v-else>
            <tr>
              <th colspan="6">{{ addlicenseschoice === 'needed' ? 'No linked SIMs need renewal.' : 'No operating SIMs linked to this team.' }}</th>
            </tr>
          </tbody>
          </table>
        </div>
      </section>

      <section v-if="inactiveLinkedTeamSims.length > 0" class="team-details-section team-details-inactive-sims">
        <div class="team-details-section-heading"><h3>Not renewed <span>({{ inactiveLinkedTeamSims.length }})</span></h3></div>
        <p class="team-details-section-note">Stopped and closed devices are excluded from this renewal.</p>
        <div class="team-details-table-wrap">
          <table class="table table-hover team-details-table">
            <thead><tr><th>#</th><th>SIM</th><th>IMEI</th><th>Valid Until</th><th>Status</th><th>Renewal</th></tr></thead>
            <tbody>
              <tr v-for="(sim, index) in inactiveLinkedTeamSims" :key="`excluded-license-sim-${sim.id || sim.phoneNumber || index}`">
                <th>{{ index + 1 }}</th>
                <th>{{ sim.phoneNumber || "-" }}</th>
                <th>{{ sim.imei || "-" }}</th>
                <th><span :class="getLinkedTeamSimValidUntilClass(sim)">{{ getTeamSimValidUntilDisplay(sim) }}</span></th>
                <th><span :class="getLinkedTeamSimStatusClass(sim)">{{ sim.status || "-" }}</span></th>
                <th><span class="team-sim-renewal-excluded">Not eligible</span></th>
              </tr>
            </tbody>
          </table>
        </div>
      </section>
    </div>
  </Modal>


<!--MAIN-->
  <div class="col bg-light" style="width: 100%" v-if="loaded == false">
    <div class="lds-ring" style="margin-left: 50%; margin-top: 20%">
      <div></div>
      <div></div>
      <div></div>
      <div></div>
    </div>
  </div>
  <div v-else class="col bg-light teams-list-view">
    <header class="teams-list-header">
      <h1>Teams management</h1>
      <div class="teams-list-header-updated">Updated: {{ formatLastUpdated() }} <span v-if="!store.state.usersLoaded" class="teams-list-header-loading"><span class="spinner-border" aria-hidden="true"></span></span></div>
    </header>
    <div class="teams-list-toolbar">
    <div class="teams-list-page-size">
        <label for="teamEntries">Entries</label>
        <select id="teamEntries" v-model="currentEntries" class="form-control form-control-sm" v-on:change="paginateEntries">
          <option v-for="se in showEntries" :key="se" :value="se">{{ se }}</option>
        </select>
      </div>
      <div class="teams-list-actions">
          <button class="btn teams-list-secondary" v-on:click="resetTeams()">Reset filters</button>
          <button class="btn teams-list-secondary" v-on:click="addNewTeam()">Add team</button>
        <input class="search form-control form-control-sm teams-list-search" type="text" placeholder="Search.." v-model="searchInput" v-on:keyup="searchEvent"/>
      </div>
    </div>


    <div class="teams-list-columns">
      <span class="table-filter-label">Columns</span>
      <label
        v-for="column in hideableColumns"
        :key="column.name"
        class="table-column-toggle"
      >
        <input
          :checked="isColumnVisible(column.name)"
          type="checkbox"
          class="form-check-input mt-0"
          @change="setColumnVisibility(column.name, $event.target.checked)"
        />
        <span>{{ column.text }}</span>
      </label>
    </div>

    <div class="teams-list-table-wrap">
    <table id="table" :class="['table table-hover teams-data-table', tableColumnVisibilityClasses]">
      <thead>
        <tr class="h6">
          <th>
            <div class="d-flex justify-content-between">
              <span>Team Name</span>
              <span v-if="sortteamname == 'default'"><button class="btn" v-on:click.prevent="sortByColumn('teamName')"><svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" fill="currentColor" class="bi bi-arrow-down-up" viewBox="0 0 16 16"><path fill-rule="evenodd" d="M11.5 15a.5.5 0 0 0 .5-.5V2.707l3.146 3.147a.5.5 0 0 0 .708-.708l-4-4a.5.5 0 0 0-.708 0l-4 4a.5.5 0 1 0 .708.708L11 2.707V14.5a.5.5 0 0 0 .5.5zm-7-14a.5.5 0 0 1 .5.5v11.793l3.146-3.147a.5.5 0 0 1 .708.708l-4 4a.5.5 0 0 1-.708 0l-4-4a.5.5 0 0 1 .708-.708L4 13.293V1.5a.5.5 0 0 1 .5-.5z"/></svg></button></span>
              <span v-else-if="sortteamname == 'desc'"><button class="btn" v-on:click.prevent="sortByColumn('teamName')"><svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" fill="currentColor" class="bi bi-arrow-up" viewBox="0 0 16 16"><path fill-rule="evenodd" d="M8 15a.5.5 0 0 0 .5-.5V2.707l3.146 3.147a.5.5 0 0 0 .708-.708l-4-4a.5.5 0 0 0-.708 0l-4 4a.5.5 0 1 0 .708.708L7.5 2.707V14.5a.5.5 0 0 0 .5.5z"/></svg></button></span>
              <span v-else-if="sortteamname == 'asc'"><button class="btn" v-on:click.prevent="sortByColumn('teamName')"><svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" fill="currentColor" class="bi bi-arrow-down" viewBox="0 0 16 16"><path fill-rule="evenodd" d="M8 1a.5.5 0 0 1 .5.5v11.793l3.146-3.147a.5.5 0 0 1 .708.708l-4 4a.5.5 0 0 1-.708 0l-4-4a.5.5 0 0 1 .708-.708L7.5 13.293V1.5A.5.5 0 0 1 8 1z"/></svg></button></span>
            </div>
          </th>
          <th>
            <div class="d-flex justify-content-between">
              <span>Owner name</span>
              <span v-if="sortownername == 'default'"><button class="btn" v-on:click.prevent="sortByColumn('ownerName')"><svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" fill="currentColor" class="bi bi-arrow-down-up" viewBox="0 0 16 16"><path fill-rule="evenodd" d="M11.5 15a.5.5 0 0 0 .5-.5V2.707l3.146 3.147a.5.5 0 0 0 .708-.708l-4-4a.5.5 0 0 0-.708 0l-4 4a.5.5 0 1 0 .708.708L11 2.707V14.5a.5.5 0 0 0 .5.5zm-7-14a.5.5 0 0 1 .5.5v11.793l3.146-3.147a.5.5 0 0 1 .708.708l-4 4a.5.5 0 0 1-.708 0l-4-4a.5.5 0 0 1 .708-.708L4 13.293V1.5a.5.5 0 0 1 .5-.5z"/></svg></button></span>
              <span v-else-if="sortownername == 'desc'"><button class="btn" v-on:click.prevent="sortByColumn('ownerName')"><svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" fill="currentColor" class="bi bi-arrow-up" viewBox="0 0 16 16"><path fill-rule="evenodd" d="M8 15a.5.5 0 0 0 .5-.5V2.707l3.146 3.147a.5.5 0 0 0 .708-.708l-4-4a.5.5 0 0 0-.708 0l-4 4a.5.5 0 1 0 .708.708L7.5 2.707V14.5a.5.5 0 0 0 .5.5z"/></svg></button></span>
              <span v-else-if="sortownername == 'asc'"><button class="btn" v-on:click.prevent="sortByColumn('ownerName')"><svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" fill="currentColor" class="bi bi-arrow-down" viewBox="0 0 16 16"><path fill-rule="evenodd" d="M8 1a.5.5 0 0 1 .5.5v11.793l3.146-3.147a.5.5 0 0 1 .708.708l-4 4a.5.5 0 0 1-.708 0l-4-4a.5.5 0 0 1 .708-.708L7.5 13.293V1.5A.5.5 0 0 1 8 1z"/></svg></button></span>
            </div>
          </th>
          <th>
            <div class="d-flex justify-content-between">
              <span>Owner number</span>
              <span v-if="sortnumber == 'default'"><button class="btn" v-on:click.prevent="sortByColumn('phoneNumber')"><svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" fill="currentColor" class="bi bi-arrow-down-up" viewBox="0 0 16 16"><path fill-rule="evenodd" d="M11.5 15a.5.5 0 0 0 .5-.5V2.707l3.146 3.147a.5.5 0 0 0 .708-.708l-4-4a.5.5 0 0 0-.708 0l-4 4a.5.5 0 1 0 .708.708L11 2.707V14.5a.5.5 0 0 0 .5.5zm-7-14a.5.5 0 0 1 .5.5v11.793l3.146-3.147a.5.5 0 0 1 .708.708l-4 4a.5.5 0 0 1-.708 0l-4-4a.5.5 0 0 1 .708-.708L4 13.293V1.5a.5.5 0 0 1 .5-.5z"/></svg></button></span>
              <span v-else-if="sortnumber == 'desc'"><button class="btn" v-on:click.prevent="sortByColumn('phoneNumber')"><svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" fill="currentColor" class="bi bi-arrow-up" viewBox="0 0 16 16"><path fill-rule="evenodd" d="M8 15a.5.5 0 0 0 .5-.5V2.707l3.146 3.147a.5.5 0 0 0 .708-.708l-4-4a.5.5 0 0 0-.708 0l-4 4a.5.5 0 1 0 .708.708L7.5 2.707V14.5a.5.5 0 0 0 .5.5z"/></svg></button></span>
              <span v-else-if="sortnumber == 'asc'"><button class="btn" v-on:click.prevent="sortByColumn('phoneNumber')"><svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" fill="currentColor" class="bi bi-arrow-down" viewBox="0 0 16 16"><path fill-rule="evenodd" d="M8 1a.5.5 0 0 1 .5.5v11.793l3.146-3.147a.5.5 0 0 1 .708.708l-4 4a.5.5 0 0 1-.708 0l-4-4a.5.5 0 0 1 .708-.708L7.5 13.293V1.5A.5.5 0 0 1 8 1z"/></svg></button></span>
            </div>
          </th>
          <th>
            <div class="d-flex justify-content-between">
              <span>Created</span>
              <span v-if="sortcreated == 'default'"><button class="btn" v-on:click.prevent="sortByColumn('created_date')"><svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" fill="currentColor" class="bi bi-arrow-down-up" viewBox="0 0 16 16"><path fill-rule="evenodd" d="M11.5 15a.5.5 0 0 0 .5-.5V2.707l3.146 3.147a.5.5 0 0 0 .708-.708l-4-4a.5.5 0 0 0-.708 0l-4 4a.5.5 0 1 0 .708.708L11 2.707V14.5a.5.5 0 0 0 .5.5zm-7-14a.5.5 0 0 1 .5.5v11.793l3.146-3.147a.5.5 0 0 1 .708.708l-4 4a.5.5 0 0 1-.708 0l-4-4a.5.5 0 0 1 .708-.708L4 13.293V1.5a.5.5 0 0 1 .5-.5z"/></svg></button></span>
              <span v-else-if="sortcreated == 'desc'"><button class="btn" v-on:click.prevent="sortByColumn('created_date')"><svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" fill="currentColor" class="bi bi-arrow-up" viewBox="0 0 16 16"><path fill-rule="evenodd" d="M8 15a.5.5 0 0 0 .5-.5V2.707l3.146 3.147a.5.5 0 0 0 .708-.708l-4-4a.5.5 0 0 0-.708 0l-4 4a.5.5 0 1 0 .708.708L7.5 2.707V14.5a.5.5 0 0 0 .5.5z"/></svg></button></span>
              <span v-else-if="sortcreated == 'asc'"><button class="btn" v-on:click.prevent="sortByColumn('created_date')"><svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" fill="currentColor" class="bi bi-arrow-down" viewBox="0 0 16 16"><path fill-rule="evenodd" d="M8 1a.5.5 0 0 1 .5.5v11.793l3.146-3.147a.5.5 0 0 1 .708.708l-4 4a.5.5 0 0 1-.708 0l-4-4a.5.5 0 0 1 .708-.708L7.5 13.293V1.5A.5.5 0 0 1 8 1z"/></svg></button></span>
            </div>
          </th>
          <th>
            <div class="d-flex justify-content-between">
              <span>Members</span>
              <span v-if="sortmembers == 'default'"><button class="btn" v-on:click.prevent="sortByColumn('members')"><svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" fill="currentColor" class="bi bi-arrow-down-up" viewBox="0 0 16 16"><path fill-rule="evenodd" d="M11.5 15a.5.5 0 0 0 .5-.5V2.707l3.146 3.147a.5.5 0 0 0 .708-.708l-4-4a.5.5 0 0 0-.708 0l-4 4a.5.5 0 1 0 .708.708L11 2.707V14.5a.5.5 0 0 0 .5.5zm-7-14a.5.5 0 0 1 .5.5v11.793l3.146-3.147a.5.5 0 0 1 .708.708l-4 4a.5.5 0 0 1-.708 0l-4-4a.5.5 0 0 1 .708-.708L4 13.293V1.5a.5.5 0 0 1 .5-.5z"/></svg></button></span>
              <span v-else-if="sortmembers == 'desc'"><button class="btn" v-on:click.prevent="sortByColumn('members')"><svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" fill="currentColor" class="bi bi-arrow-up" viewBox="0 0 16 16"><path fill-rule="evenodd" d="M8 15a.5.5 0 0 0 .5-.5V2.707l3.146 3.147a.5.5 0 0 0 .708-.708l-4-4a.5.5 0 0 0-.708 0l-4 4a.5.5 0 1 0 .708.708L7.5 2.707V14.5a.5.5 0 0 0 .5.5z"/></svg></button></span>
              <span v-else-if="sortmembers == 'asc'"><button class="btn" v-on:click.prevent="sortByColumn('members')"><svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" fill="currentColor" class="bi bi-arrow-down" viewBox="0 0 16 16"><path fill-rule="evenodd" d="M8 1a.5.5 0 0 1 .5.5v11.793l3.146-3.147a.5.5 0 0 1 .708.708l-4 4a.5.5 0 0 1-.708 0l-4-4a.5.5 0 0 1 .708-.708L7.5 13.293V1.5A.5.5 0 0 1 8 1z"/></svg></button></span>
            </div>
          </th>
          <th>
            <div class="d-flex justify-content-between">
              <span>Team-paid</span>
              <span v-if="sortfullmembers == 'default'"><button class="btn" v-on:click.prevent="sortByColumn('fullmembers')"><svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" fill="currentColor" class="bi bi-arrow-down-up" viewBox="0 0 16 16"><path fill-rule="evenodd" d="M11.5 15a.5.5 0 0 0 .5-.5V2.707l3.146 3.147a.5.5 0 0 0 .708-.708l-4-4a.5.5 0 0 0-.708 0l-4 4a.5.5 0 1 0 .708.708L11 2.707V14.5a.5.5 0 0 0 .5.5zm-7-14a.5.5 0 0 1 .5.5v11.793l3.146-3.147a.5.5 0 0 1 .708.708l-4 4a.5.5 0 0 1-.708 0l-4-4a.5.5 0 0 1 .708-.708L4 13.293V1.5a.5.5 0 0 1 .5-.5z"/></svg></button></span>
              <span v-else-if="sortfullmembers == 'desc'"><button class="btn" v-on:click.prevent="sortByColumn('fullmembers')"><svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" fill="currentColor" class="bi bi-arrow-up" viewBox="0 0 16 16"><path fill-rule="evenodd" d="M8 15a.5.5 0 0 0 .5-.5V2.707l3.146 3.147a.5.5 0 0 0 .708-.708l-4-4a.5.5 0 0 0-.708 0l-4 4a.5.5 0 1 0 .708.708L7.5 2.707V14.5a.5.5 0 0 0 .5.5z"/></svg></button></span>
              <span v-else-if="sortfullmembers == 'asc'"><button class="btn" v-on:click.prevent="sortByColumn('fullmembers')"><svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" fill="currentColor" class="bi bi-arrow-down" viewBox="0 0 16 16"><path fill-rule="evenodd" d="M8 1a.5.5 0 0 1 .5.5v11.793l3.146-3.147a.5.5 0 0 1 .708.708l-4 4a.5.5 0 0 1-.708 0l-4-4a.5.5 0 0 1 .708-.708L7.5 13.293V1.5A.5.5 0 0 1 8 1z"/></svg></button></span>
            </div>
          </th>
          <th>
            <div class="d-flex justify-content-between">
              <span>Not team-paid</span>
              <span v-if="sortothermembers == 'default'"><button class="btn" v-on:click.prevent="sortByColumn('othermembers')"><svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" fill="currentColor" class="bi bi-arrow-down-up" viewBox="0 0 16 16"><path fill-rule="evenodd" d="M11.5 15a.5.5 0 0 0 .5-.5V2.707l3.146 3.147a.5.5 0 0 0 .708-.708l-4-4a.5.5 0 0 0-.708 0l-4 4a.5.5 0 1 0 .708.708L11 2.707V14.5a.5.5 0 0 0 .5.5zm-7-14a.5.5 0 0 1 .5.5v11.793l3.146-3.147a.5.5 0 0 1 .708.708l-4 4a.5.5 0 0 1-.708 0l-4-4a.5.5 0 0 1 .708-.708L4 13.293V1.5a.5.5 0 0 1 .5-.5z"/></svg></button></span>
              <span v-else-if="sortothermembers == 'desc'"><button class="btn" v-on:click.prevent="sortByColumn('othermembers')"><svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" fill="currentColor" class="bi bi-arrow-up" viewBox="0 0 16 16"><path fill-rule="evenodd" d="M8 15a.5.5 0 0 0 .5-.5V2.707l3.146 3.147a.5.5 0 0 0 .708-.708l-4-4a.5.5 0 0 0-.708 0l-4 4a.5.5 0 1 0 .708.708L7.5 2.707V14.5a.5.5 0 0 0 .5.5z"/></svg></button></span>
              <span v-else-if="sortothermembers == 'asc'"><button class="btn" v-on:click.prevent="sortByColumn('othermembers')"><svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" fill="currentColor" class="bi bi-arrow-down" viewBox="0 0 16 16"><path fill-rule="evenodd" d="M8 1a.5.5 0 0 1 .5.5v11.793l3.146-3.147a.5.5 0 0 1 .708.708l-4 4a.5.5 0 0 1-.708 0l-4-4a.5.5 0 0 1 .708-.708L7.5 13.293V1.5A.5.5 0 0 1 8 1z"/></svg></button></span>
            </div>
          </th>
          <th>
            <div class="d-flex justify-content-between">
              <span>Licenses</span>
              <span v-if="sortlicensescount == 'default'"><button class="btn" v-on:click.prevent="sortByColumn('licenceCount')"><svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" fill="currentColor" class="bi bi-arrow-down-up" viewBox="0 0 16 16"><path fill-rule="evenodd" d="M11.5 15a.5.5 0 0 0 .5-.5V2.707l3.146 3.147a.5.5 0 0 0 .708-.708l-4-4a.5.5 0 0 0-.708 0l-4 4a.5.5 0 1 0 .708.708L11 2.707V14.5a.5.5 0 0 0 .5.5zm-7-14a.5.5 0 0 1 .5.5v11.793l3.146-3.147a.5.5 0 0 1 .708.708l-4 4a.5.5 0 0 1-.708 0l-4-4a.5.5 0 0 1 .708-.708L4 13.293V1.5a.5.5 0 0 1 .5-.5z"/></svg></button></span>
              <span v-else-if="sortlicensescount == 'desc'"><button class="btn" v-on:click.prevent="sortByColumn('licenceCount')"><svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" fill="currentColor" class="bi bi-arrow-up" viewBox="0 0 16 16"><path fill-rule="evenodd" d="M8 15a.5.5 0 0 0 .5-.5V2.707l3.146 3.147a.5.5 0 0 0 .708-.708l-4-4a.5.5 0 0 0-.708 0l-4 4a.5.5 0 1 0 .708.708L7.5 2.707V14.5a.5.5 0 0 0 .5.5z"/></svg></button></span>
              <span v-else-if="sortlicensescount == 'asc'"><button class="btn" v-on:click.prevent="sortByColumn('licenceCount')"><svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" fill="currentColor" class="bi bi-arrow-down" viewBox="0 0 16 16"><path fill-rule="evenodd" d="M8 1a.5.5 0 0 1 .5.5v11.793l3.146-3.147a.5.5 0 0 1 .708.708l-4 4a.5.5 0 0 1-.708 0l-4-4a.5.5 0 0 1 .708-.708L7.5 13.293V1.5A.5.5 0 0 1 8 1z"/></svg></button></span>
            </div>
          </th>
          <th>
            <div class="d-flex justify-content-between">
              <span>Valid until</span>
              <span v-if="sortvaliduntil == 'default'"><button class="btn" v-on:click.prevent="sortByColumn('validUntil')"><svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" fill="currentColor" class="bi bi-arrow-down-up" viewBox="0 0 16 16"><path fill-rule="evenodd" d="M11.5 15a.5.5 0 0 0 .5-.5V2.707l3.146 3.147a.5.5 0 0 0 .708-.708l-4-4a.5.5 0 0 0-.708 0l-4 4a.5.5 0 1 0 .708.708L11 2.707V14.5a.5.5 0 0 0 .5.5zm-7-14a.5.5 0 0 1 .5.5v11.793l3.146-3.147a.5.5 0 0 1 .708.708l-4 4a.5.5 0 0 1-.708 0l-4-4a.5.5 0 0 1 .708-.708L4 13.293V1.5a.5.5 0 0 1 .5-.5z"/></svg></button></span>
              <span v-else-if="sortvaliduntil == 'desc'"><button class="btn" v-on:click.prevent="sortByColumn('validUntil')"><svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" fill="currentColor" class="bi bi-arrow-up" viewBox="0 0 16 16"><path fill-rule="evenodd" d="M8 15a.5.5 0 0 0 .5-.5V2.707l3.146 3.147a.5.5 0 0 0 .708-.708l-4-4a.5.5 0 0 0-.708 0l-4 4a.5.5 0 1 0 .708.708L7.5 2.707V14.5a.5.5 0 0 0 .5.5z"/></svg></button></span>
              <span v-else-if="sortvaliduntil == 'asc'"><button class="btn" v-on:click.prevent="sortByColumn('validUntil')"><svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" fill="currentColor" class="bi bi-arrow-down" viewBox="0 0 16 16"><path fill-rule="evenodd" d="M8 1a.5.5 0 0 1 .5.5v11.793l3.146-3.147a.5.5 0 0 1 .708.708l-4 4a.5.5 0 0 1-.708 0l-4-4a.5.5 0 0 1 .708-.708L7.5 13.293V1.5A.5.5 0 0 1 8 1z"/></svg></button></span>
            </div>
          </th>
          <th>
            <div class="d-flex justify-content-between">
              <span>Details</span>
            </div>
          </th>
        </tr>

        <tr>
          <th>
            <input type="search" class="form-control form-control-sm search" placeholder="" aria-label="Team Name" v-model="col.teamName" v-on:keyup="filterByColumn"/>
          </th>
          <th>
            <input type="search" class="form-control form-control-sm search" placeholder="" aria-label="Owner name" v-model="col.ownerName" v-on:keyup="filterByColumn"/>
          </th>
          <th>
            <input type="search" class="form-control form-control-sm search" placeholder="" aria-label="Owner number" v-model="col.phoneNumber" v-on:keyup="filterByColumn"/>
          </th>
          <th>
            <input type="search" class="form-control form-control-sm search" placeholder="" aria-label="Created" v-model="col.created_date" v-on:keyup="filterByColumn"/>
          </th>
          <th>
            <div class="numberSearch">
              <input type="search" class="form-control form-control-sm" v-model="col.membersmin" @keyup="filterByColumn"/>-
              <input type="search" class="form-control form-control-sm" v-model="col.membersmax" @keyup="filterByColumn"/>
            </div>
          </th>
          <th>
            <div class="numberSearch">
              <input type="search" class="form-control form-control-sm" v-model="col.fullmembersmin" @keyup="filterByColumn"/>-
              <input type="search" class="form-control form-control-sm" v-model="col.fullmembersmax" @keyup="filterByColumn"/>
            </div>
          </th>
          <th>
            <div class="numberSearch">
              <input type="search" class="form-control form-control-sm" v-model="col.othermembersmin" @keyup="filterByColumn"/>-
              <input type="search" class="form-control form-control-sm" v-model="col.othermembersmax" @keyup="filterByColumn"/>
            </div>
          </th>
          <th>
            <div class="numberSearch">
              <input type="search" class="form-control form-control-sm" v-model="col.licenceCountmin" @keyup="filterByColumn"/>-
              <input type="search" class="form-control form-control-sm" v-model="col.licenceCountmax" @keyup="filterByColumn"/>
            </div>
          </th>
          <th>
            <div class="numberSearch">
              <input type="search" class="form-control form-control-sm" v-model="col.validUntilmin" @keyup="filterByColumn"/>-
              <input type="search" class="form-control form-control-sm" v-model="col.validUntilmax" @keyup="filterByColumn"/>
            </div>
          </th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="td in tableData" :key="td">
          <td>{{ td.teamName }}</td>
          <td>{{ td.ownerName }}</td>
          <td>{{ td.phoneNumber }}</td>
          <td>{{ td.created_date }}</td>
          <td>{{ td.members }}</td>
          <td>
            <div :class="getTeamPaidClass(td)">{{ td.fullmembers }}</div>
          </td>
          <td>{{ td.othermembers }}</td>
          <td>{{ td.licenceCount }}</td>
          <td>
            <div :class="getValidUntilClass(td.validUntil)">{{ td.validDate }}</div>
          </td>
          <td class="teams-data-details-cell">
            <svg v-on:click="teamsInfo(td)" xmlns="http://www.w3.org/2000/svg" width="14" height="14" fill="currentColor" class="bi bi-info-circle" viewBox="0 0 16 16"><path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"/><path d="m8.93 6.588-2.29.287-.082.38.45.083c.294.07.352.176.288.469l-.738 3.468c-.194.897.105 1.319.808 1.319.545 0 1.178-.252 1.465-.598l.088-.416c-.2.176-.492.246-.686.246-.275 0-.375-.193-.304-.533L8.93 6.588zM9 4.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0z"/></svg>
          </td>
        </tr>
      </tbody>
    </table>
    </div>

    <div class="d-flex d-flex justify-content-between mb-1">
      <div style="font-size: 12px">Show {{ showInfo.from }} to {{ showInfo.to }} of {{ showInfo.of }} entries</div>
      <div style="font-size: 10px">
        <ul class="list-group list-group-horizontal mb-1">
          <li :class="['list-group-item border px-2', { disabled: currentPage === 1 },]">
            <a href="#" class="nav-link" v-on:click.prevent="(currentPage = 1), paginateEntries()">First</a>
          </li>
          <li :class="['list-group-item border px-2', { disabled: currentPage === 1 },]">
            <a href="#" class="nav-link" @click.prevent="currentPage < 1 ? (currentPage = 1) : (currentPage -= 1), paginateEntries()">Prev</a>
          </li>
          <li v-for="pagi in showPagination" :key="pagi" :class="['list-group-item border px-2', { ellipsis: pagi === '...', active: pagi === currentPage },]">
            <a href="#" class="nav-link bg-white text-dark" v-on:click.prevent="paginateEvent(pagi)">{{ pagi }}</a>
          </li>
          <li :class="['list-group-item border px-2', { disabled: currentPage === allPages },]">
            <a href="#" class="nav-link" v-on:click.prevent="currentPage > allPages ? (currentPage = allPages) : (currentPage += 1), paginateEntries()">Next</a>
          </li>
          <li :class="['list-group-item border px-2', { disabled: currentPage === allPages },]">
            <a href="#" class="nav-link" v-on:click.prevent="(currentPage = allPages), paginateEntries()">Last</a>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios"
import * as $ from "alga-js"
import { ref } from "vue"
import Modal from "@/components/Modal.vue"
import UserDetailsModal from "@/components/UserDetailsModal.vue"
import SimDetailsModal from '@/components/SimDetailsModal.vue'
import firebase from "firebase/compat/app"
import "firebase/compat/auth"
import { inject } from 'vue'
import { mapState } from 'vuex'
import { API_ENDPOINTS } from '@/config/api'
import {
  simBelongsToTeam
} from '@/utils/simTeamLink'
import { getLicenseValidUntilTimestamp, getLongestValidLicense, normalizeAdminUser } from '@/utils/userUtils'

const DAY_MS = 24 * 60 * 60 * 1000

export default {
  name: "TeamsTable",
  components: {
    Modal,
    UserDetailsModal,
    SimDetailsModal,
  },
  setup() {
    const store = inject('store')
    const popupTriggers = ref({
      teamInfoTrigger: false,
      userInfoTrigger: false,
      simDetailsTrigger: false,
      addNewTeamTrigger: false,
      changeTeamTrigger: false,
      addMembersTrigger: false,
      activateLicenseTrigger: false,
    })
    const TogglePopup = (trigger) => {
      popupTriggers.value[trigger] = !popupTriggers.value[trigger]
    };
    return {
      Modal,
      popupTriggers,
      TogglePopup,
      store
    };
  },
  mounted() {
    if(!this.store.state.usersLoaded){
      this.$store.dispatch('loadUsers')
    }
  },
  data() {
    //SORTEERIMINE JA FILTREERIMINE JÄI POOLELI
    return {
      //SORT ICONS
      sortnumber: "default",
      sortownername: "default",
      sortteamname: "default",
      sortcreated: "default",
      sortmembers: "default",
      sortfullmembers: "default",
      sortothermembers: "default",
      sortlicensescount: "default",
      sortvaliduntil: "default",
      //TOGGLES
      togglelicenses: false,
      toggledevices: false,
      togglenotes: false,
      togglepermissions: false,
      togglefullmembers: false,
      togglenewlicense: false,
      //OTHER
      datenow: new Date().getTime(),
      datemonth: new Date().getTime() + 2629800000,
      title: "Teams",
      portalPIN: "",
      usersLoaded: false,
      loaded: false,
      permission: "",
      userLicenseDate: 0,
      last_updated: 0,
      teamHuntCodeInput: "",
      selectedTeamSim: {},
      isGeneratingHuntCode: false,
      columns: [
        { name: "teamName", text: "Team Name" },
        { name: "ownerName", text: "Owner name" },
        { name: "phoneNumber", text: "Owner number" },
        { name: "created_date", text: "Created" },
        { name: "members", text: "Members" },
        { name: "fullmembers", text: "Team-paid" },
        { name: "othermembers", text: "Not team-paid" },
        { name: "licenceCount", text: "Licenses" },
        { name: "validUntil", text: "validUntil"},
        { name: "details", text: "Details" },
      ],
      columnVisibility: {
        ownerName: true,
        phoneNumber: true,
        created_date: true,
        members: true,
        fullmembers: true,
        othermembers: true,
        licenceCount: true,
        validUntil: true,
        details: true,
      },
      entries: [],
      allEntries: [],
      filterentries: [],
      defaultentries: [],
      showEntries: [1, 5, 10, 15, 25, 50, 100, 500],
      currentEntries: 50,
      filteredEntries: [],
      currentPage: 1,
      allPages: 1,
      searchInput: "",
      searchEntries: [],
      newMembersInput: "",
      newMembersPreview: [],
      newMembersChecked: false,
      newMembersSubmitting: false,
      addlicenseschoice: "all",
      customlicense: [],
      teamLicenseComment: "",
      allSims: [],
      teamSimsLoaded: false,
      team: {
        permissions: []
      },
      user: {
        userdata: {
          teamsinfo: []
        }
      },
      col: {
        teamName: "",
        ownerName: "",
        phoneNumber: "",
        created_date: "",
        membersmin: "",
        membersmax: "",
        fullmembers: "",
        othermembers: "",
        licenceCount: "",
        validUntil: ""
      },
      sortcol: {
        teamName: "",
        ownerName: "",
        phoneNumber: "",
        created_date: "",
        members: "",
        fullmembers: "",
        othermembers: "",
        licenceCount: "",
        validUntil: ""
      },
    };
  },
  computed: {
    showInfo() {
      return $.array.pageInfo(this.getCurrentEntries(), this.currentPage, this.currentEntries)
    },
    showPagination() {
      return $.array.pagination(this.allPages, this.currentPage, 3)
    },
    tableColumns() {
      return this.columns
    },
    hideableColumns() {
      return this.columns.slice(1)
    },
    tableColumnVisibilityClasses() {
      return this.hideableColumns
        .filter((column) => this.columnVisibility[column.name] === false)
        .map((column) => `hide-column-${column.name}`)
    },
    tableData() {
      return this.filteredEntries
    },
    teamMemberRows() {
      return this.sortTeamPermissionsForDisplay(this.team.permissions)
    },
    teamLicenseMemberRows() {
      const members = this.sortMembersByName(this.team.permissions)

      if (this.addlicenseschoice === "all") {
        return members.filter((member) => member?.fullMember === true)
      }

      if (this.addlicenseschoice === "needed") {
        return members.filter((member) => member?.fullMember === true && this.memberNeedsTeamLicense(member))
      }

      return members
    },
    existingNewMembersPreview() {
      return this.newMembersPreview.filter((member) => member.isExisting)
    },
    newOnlyMembersPreview() {
      return this.newMembersPreview.filter((member) => !member.isExisting)
    },
    submittableNewMembersPreview() {
      return this.newMembersPreview.filter((member) => member.alreadyInTeam !== true)
    },
    linkedTeamSims() {
      if (!this.team || !Array.isArray(this.allSims)) return []

      return this.allSims
        .filter((sim) => simBelongsToTeam(sim, this.team, this.entries))
        .slice()
        .sort((leftSim, rightSim) => {
          const leftNumber = String(leftSim?.phoneNumber || '')
          const rightNumber = String(rightSim?.phoneNumber || '')
          return leftNumber.localeCompare(rightNumber, 'et', { sensitivity: 'base' })
        })
    },
    activeLinkedTeamSims() {
      return this.linkedTeamSims.filter((sim) => !this.isInactiveTeamSim(sim))
    },
    inactiveLinkedTeamSims() {
      return this.linkedTeamSims.filter((sim) => this.isInactiveTeamSim(sim))
    },
    teamLicenseSimRows() {
      if (this.addlicenseschoice === "needed") {
        return this.activeLinkedTeamSims.filter((sim) => this.shouldExtendTeamSim(sim))
      }

      return this.activeLinkedTeamSims.slice()
    },
    teamLicenseSimsToUpdate() {
      return this.teamLicenseSimRows.filter((sim) => this.shouldExtendTeamSim(sim))
    },
    computed: mapState(['users']),
  },
  created() {
    this.getTeams()
  },
  watch: {
    '$route.query.team'() {
      this.openRequestedTeamDetails()
    }
  },
  methods: {
    formatLastUpdated() {
      const value = String(this.last_updated || '').trim()
      if (!value) return '-'
      if (/\d{1,2}\.\d{1,2}\.\d{4}/.test(value)) return value

      return `${new Date().toLocaleDateString('et-EE')} ${value}`
    },
    isColumnVisible(columnName) {
      return this.columnVisibility[columnName] !== false
    },
    setColumnVisibility(columnName, isVisible) {
      this.columnVisibility[columnName] = isVisible
    },
    async ensureTeamSimsLoaded() {
      if (this.teamSimsLoaded) return this.allSims

      const backendAPI = API_ENDPOINTS.TIW_API + "/sim/all"
      try {
        const res = await axios.get(backendAPI)
        this.allSims = Array.isArray(res.data) ? res.data : []
        this.teamSimsLoaded = true
      } catch (error) {
        this.allSims = []
      }
      return this.allSims
    },
    //GET REQUESTS
    //BASE GET API for Teams
    async getTeams() {
      let teamAPI = API_ENDPOINTS.TIW_API + "/team/list_all"
      axios.get(teamAPI).then((res) => {
        this.entries = res.data
        for (let i = 0; i < this.entries.length; i++) {
          this.entries[i].created_date = this.formatCreatedDate(this.entries[i].created)
          this.entries[i].licenceCountmin = this.entries[i].licenceCount
          this.entries[i].licenceCountmax = this.entries[i].licenceCount
          
          //Valid until to date format
          this.entries[i].validDate = ""
          this.entries[i].validUntilmin = this.entries[i].validUntil
          this.entries[i].validUntilmax = this.entries[i].validUntil
          if(this.entries[i].validUntil != 0 && this.entries[i].validUntil != null){
            let date = this.entries[i].validUntil
            let y = new Date(date).getFullYear()
            let m = ("0" + (new Date(date).getMonth() + 1)).slice(-2)
            let d = ("0" + (new Date(date).getDate())).slice(-2)
            this.entries[i].validDate = y+"-"+m+"-"+d
          }

          //Other information
          this.entries[i].phoneNumber = ""
          this.entries[i].ownerName = ""
          this.entries[i].teamName = ""
          this.entries[i].members = 0
          if(this.entries[i].permissions.length != 0 || this.entries[i].permissions.length != null) {
            this.entries[i].members = this.entries[i].permissions.length
            this.entries[i].membersmin = this.entries[i].members
            this.entries[i].membersmax = this.entries[i].members
            this.entries[i].fullmembers = 0
            this.entries[i].othermembers = 0
            for (let j = 0; j < this.entries[i].permissions.length; j++) {
              if(this.entries[i].permissions[j].fullMember == true) this.entries[i].fullmembers++
              else this.entries[i].othermembers++
              this.entries[i].permissions[j].userdata = []
              if (this.entries[i].permissions[j].permission == "owner") {
                this.entries[i].phoneNumber = this.entries[i].permissions[j].user.phoneNumber
                this.entries[i].ownerName = this.entries[i].permissions[j].user.name
              }
            }
            if (this.entries[i].name != null) this.entries[i].teamName = this.entries[i].name
            this.entries[i].fullmembersmax = this.entries[i].fullmembers
            this.entries[i].fullmembersmin = this.entries[i].fullmembers
            this.entries[i].othermembersmax = this.entries[i].othermembers
            this.entries[i].othermembersmin = this.entries[i].othermembers
          }
        }
        this.allEntries = this.entries
        this.filterentries = this.entries
        this.defaultentries = this.allEntries
        this.paginateData(this.entries)
        this.allPages = $.array.pages(this.entries, this.currentEntries)
        this.loaded = true
        this.last_updated = localStorage.getItem('last_updated')
        this.openRequestedTeamDetails()
      })
    },

    async openRequestedTeamDetails() {
      const requestedTeamName = String(this.$route?.query?.team || '').trim()
      const requestedOwnerNumber = String(this.$route?.query?.owner || '').trim()

      if (!requestedTeamName || !Array.isArray(this.entries) || this.entries.length === 0) {
        return
      }

      const team = this.entries.find((entry) => {
        const teamName = String(entry.teamName || entry.name || '').trim()
        return (teamName === requestedTeamName || String(entry.uuid || '') === requestedTeamName) &&
          (!requestedOwnerNumber || String(entry.phoneNumber || '').trim() === requestedOwnerNumber)
      })

      if (!team) return

      await this.teamsInfo(team)
      this.popupTriggers.teamInfoTrigger = true
      this.popupTriggers.userInfoTrigger = false
      this.popupTriggers.simDetailsTrigger = false
      this.$router.replace({
        name: 'Teams',
        query: {}
      })
    },

    //TEAM DETAILS SCREEN INFO
    async teamsInfo(team) {
      this.users = this.getLoadedUsersCollection()
      this.team = team
      await this.ensureTeamSimsLoaded()
      //Sync users to team members
      for (let i = 0; i < this.team.permissions.length; i++) {
        for (let j = 0; j < this.users.length; j++) {
          if (this.team.permissions[i].user.phoneNumber ===this.users[j].cellnumber) {
            this.team.permissions[i].userdata = this.users[j]
            break
          }
        }
        if (this.team.permissions[i].userdata == null || typeof this.team.permissions[i].userdata !== "object" || Array.isArray(this.team.permissions[i].userdata)) {
          this.team.permissions[i].userdata = this.buildPlaceholderTeamUserData({
            phoneNumber: this.team.permissions[i]?.user?.phoneNumber || "",
            displayName: this.team.permissions[i]?.user?.name || ""
          })
        }
        this.team.permissions[i].userdata.teamsinfo = []
        let cellnumber = this.team.permissions[i].user.phoneNumber
        for (let j = 0; j < this.entries.length; j++){
          let team = this.entries[j]
          for (let k = 0; k < team.permissions.length; k++){
            let member = team.permissions[k]
            if(member.user.phoneNumber === cellnumber){
              let teamname = team.teamName
              let role = member.permission
              let name = team.ownerName
              let number = team.phoneNumber
              this.team.permissions[i].userdata.teamsinfo.push({
                teamName: teamname,
                teamRole: role,
                teamOwner: name,
                teamOwnerNumber: number
              })
            }
          }
        }
      }
      this.teamTrigger()
    },

    //USER DETAILS SCREEN INFO
    userInfo(user) {
      this.user = user
      if (this.user.userdata == null) {
        this.user.userdata = this.buildPlaceholderTeamUserData({
          phoneNumber: user?.user?.phoneNumber || "",
          displayName: user?.user?.name || ""
        })
      }
      this.user.userdata.created_date = this.formatCreatedDate(this.user.userdata.created)
      this.user.userdata.last_joined_date = this.formatCreatedDate(this.user.userdata.last_joined)
     
      let notearraylength = 0
      let apiURL = API_ENDPOINTS.TIW_API + "/activity/" + user.userdata.cellnumber
      axios.get(apiURL).then((res) => {
        this.user.userdata.notes = res.data
        notearraylength = this.user.userdata.notes.length
        this.user.userdata.notesarraylength = notearraylength
        this.userTrigger()
      })
    },

    //TOGGLES__________________________________________________________________________
    toggleDevices() {
      this.toggledevices = !this.toggledevices
    },
    openSimDetails(sim) {
      this.selectedTeamSim = sim || {}
      this.popupTriggers.simDetailsTrigger = true
    },
    openSimUserDetails(user) {
      this.user = { userdata: normalizeAdminUser(user) }
      this.popupTriggers.simDetailsTrigger = false
      this.popupTriggers.userInfoTrigger = true
    },
    toggleLicenses() {
      this.togglelicenses = !this.togglelicenses
    },
    toggleNotes() {
      this.togglenotes = !this.togglenotes
    },
    togglePermissions() {
      this.togglepermissions = !this.togglepermissions
    },
    toggleFullMember() {
      this.togglefullmembers = !this.togglefullmembers
    },
    toggleUserLicense() {
      this.togglenewlicense = !this.togglenewlicense
      let def = Date.now() + 31556952000
      let y = new Date(def).getFullYear()
      let m = ("0" + (new Date(def).getMonth() + 1)).slice(-2)
      let d = ("0" + (new Date(def).getDate())).slice(-2)
      this.userLicenseDate = y+"-"+m+"-"+d
    },
    toggleAddChoice(option) {
      this.addlicenseschoice = option
    },
    getAddChoiceButtonClass(option) {
      const isSelected = this.addlicenseschoice === option
      return isSelected
        ? "btn btn-sm btn-primary btn-rounded"
        : "btn btn-sm btn-outline-dark btn-rounded"
    },
    //TRIGGERS_______________________________________________________________
    addNewTeam() {
      this.TogglePopup("addNewTeamTrigger")
      setTimeout(() => {}, 1)
    },
    changeTeam() {
      let def = Date.now() + 31556952000
      let y = new Date(def).getFullYear()
      let m = ("0" + (new Date(def).getMonth() + 1)).slice(-2)
      let d = ("0" + (new Date(def).getDate())).slice(-2)
      this.teamLicenseDate = y+"-"+m+"-"+d
      this.teamHuntCodeInput = this.team?.permanentHuntCode || ""
      this.TogglePopup("changeTeamTrigger")
      setTimeout(() => {}, 1)
    },
    addMembers() {
      const isOpening = !this.popupTriggers.addMembersTrigger
      this.TogglePopup("addMembersTrigger")
      if (isOpening) {
        this.resetNewMembersState()
      }
      setTimeout(() => {}, 1)
    },
    async AddLicenses() {
      const isOpening = !this.popupTriggers.activateLicenseTrigger
      this.TogglePopup("activateLicenseTrigger")
      if (isOpening) {
        this.addlicenseschoice = "all"
        this.customlicense = []
        this.teamLicenseComment = this.getDefaultTeamLicenseComment()
        await this.ensureTeamSimsLoaded()
      }
      setTimeout(() => {}, 1)
    },
    userTrigger() {
      this.TogglePopup("userInfoTrigger")
      setTimeout(() => {}, 1)
    },
    teamTrigger() {
      this.TogglePopup("teamsInfoTrigger")
      setTimeout(() => {}, 1)
    },


    //POST REQUESTS_________________________________________________________________
    //BASE TEAM UPLOAD
    submitNewTeam() {
      let name = document.getElementById("teamNameInput")
      let cellnumber = document.getElementById("teamOwnerInput")
      if (name.value == "" || cellnumber.value == "") return alert("No number or name given!")
      else {
        let backendAPI = API_ENDPOINTS.TIW_API + "/team/" + cellnumber.value
        let body = { name: name.value }
        axios.post(backendAPI, body).then((res) => {
          let newTeam = res.data
          newTeam.created_date = this.formatCreatedDate(newTeam.created)
          newTeam.members = 1
          newTeam.membersmin = 1
          newTeam.membersmax = 1
          newTeam.othermembers = 1
          newTeam.othermembersmin = 1
          newTeam.othermembersmax = 1
          newTeam.fullmembers = 0
          newTeam.fullmembersmin = 0
          newTeam.fullmembersmax = 0
          newTeam.teamName = newTeam.name
          newTeam.ownerName = newTeam.permissions[0].user.name
          newTeam.phoneNumber = newTeam.permissions[0].user.phoneNumber
          const entryCollections = new Set([this.allEntries, this.entries])
          entryCollections.forEach((collection) => {
            if (Array.isArray(collection)) collection.push(newTeam)
          })
          this.filterentries = this.entries
          this.defaultentries = this.allEntries
          this.paginateData(this.entries)
          this.allPages = $.array.pages(this.entries, this.currentEntries)
          alert("Team "+newTeam.teamName+" has been added")
          this.addNewTeam()
        })
      }
    },
    //POST NEW MEMBERS
    async prepareNewMembers() {
      this.resetNewMembersPreview()
      this.newMembersInput = this.sanitizeNewMembersInput(this.newMembersInput)
      const checkedInput = this.newMembersInput
      const invalidLines = checkedInput.split("\n")
        .map((line, index) => line && !this.normalizeNewMemberPhoneNumber(line) ? index + 1 : null)
        .filter((lineNumber) => lineNumber !== null)
      if (invalidLines.length > 0) {
        alert(`Invalid phone number on line(s): ${invalidLines.join(", ")}. Use digits and at most one + at the beginning.`)
        return
      }

      const phoneNumbers = this.parseNewMembersInput(this.newMembersInput)
      if (phoneNumbers.length === 0) {
        alert("Please enter at least one phone number.")
        return
      }

      const users = await this.ensureUsersLoadedForTeamMembers()
      if (this.newMembersInput !== checkedInput) return
      if (!Array.isArray(users) || users.length === 0) {
        alert("User list is still loading. Please try again in a moment.")
        return
      }

      const currentTeamNumbers = new Set(
        (Array.isArray(this.team?.permissions) ? this.team.permissions : [])
          .map((member) => this.normalizeNewMemberPhoneNumber(member?.user?.phoneNumber))
          .filter((phoneNumber) => phoneNumber.length > 0)
      )

      const existingMembers = []
      const newMembers = []

      for (const phoneNumber of phoneNumbers) {
        const existingUser = this.findExistingUserByPhoneNumber(phoneNumber, users)
        const previewMember = {
          phoneNumber,
          isExisting: existingUser != null,
          existingUser,
          displayName: existingUser?.name || "",
          manualName: "",
          licenseDate: existingUser?.last_license_date || "",
          alreadyInTeam: currentTeamNumbers.has(phoneNumber)
        }

        if (previewMember.isExisting) {
          existingMembers.push(previewMember)
        }
        else {
          newMembers.push(previewMember)
        }
      }

      existingMembers.sort((leftMember, rightMember) => {
        const leftName = String(leftMember.displayName || "").trim()
        const rightName = String(rightMember.displayName || "").trim()
        const byName = leftName.localeCompare(rightName, "et", { sensitivity: "base" })
        if (byName !== 0) return byName
        return String(leftMember.phoneNumber).localeCompare(String(rightMember.phoneNumber), "et", { sensitivity: "base" })
      })

      newMembers.sort((leftMember, rightMember) => {
        return String(leftMember.phoneNumber).localeCompare(String(rightMember.phoneNumber), "et", { sensitivity: "base" })
      })

      this.newMembersPreview = [...existingMembers, ...newMembers]
      this.newMembersChecked = true
    },
    async submitPreparedMembers(team) {
      if (this.newMembersSubmitting) return
      const membersToAdd = []
      const seenPhoneNumbers = new Set()
      for (const previewMember of this.submittableNewMembersPreview) {
        const phoneNumber = this.normalizeNewMemberPhoneNumber(previewMember.phoneNumber)
        if (!phoneNumber) {
          alert("Invalid phone number. Check the member list again before adding members.")
          return
        }
        if (seenPhoneNumbers.has(phoneNumber)) continue
        seenPhoneNumbers.add(phoneNumber)
        previewMember.phoneNumber = phoneNumber
        membersToAdd.push(previewMember)
      }
      if (membersToAdd.length === 0) {
        alert("No new team members to add.")
        return
      }

      this.newMembersSubmitting = true

      try {
        const backendAPI = API_ENDPOINTS.TIW_API + "/team/" + team.uuid + "/permissions/" + team.phoneNumber
        const alreadyInTeamCount = this.newMembersPreview.filter((member) => member.alreadyInTeam === true).length
        let addedCount = 0
        let restoredCount = 0
        const failures = []

        for (const previewMember of membersToAdd) {
          previewMember.submissionStatus = "pending"
          previewMember.submissionError = ""
          const body = {
            user: {
              phoneNumber: previewMember.phoneNumber,
            },
            permission: "view",
            fullMember: true
          }

          try {
            const res = await axios.post(backendAPI, body)
            this.applyNewTeamMember(team, res.data || {}, previewMember)
            previewMember.alreadyInTeam = true
            previewMember.submissionStatus = res.data?.restored === true ? "restored" : "added"
            if (previewMember.submissionStatus === "restored") restoredCount += 1
            else addedCount += 1
          } catch (error) {
            previewMember.submissionStatus = "failed"
            previewMember.submissionError = this.getNewMemberAddError(error)
            const label = previewMember.displayName
              ? `${previewMember.phoneNumber} (${previewMember.displayName})`
              : previewMember.phoneNumber
            failures.push(`${label}: ${previewMember.submissionError}`)
          }
        }

        this.filterentries = this.entries
        this.defaultentries = this.allEntries
        this.paginateData(this.entries)
        this.allPages = $.array.pages(this.entries, this.currentEntries)
        let resultMessage = `Added ${addedCount} member`
        if (addedCount !== 1) resultMessage += "s"
        if (restoredCount > 0) {
          resultMessage += `. Restored ${restoredCount} former member${restoredCount === 1 ? "" : "s"}`
        }
        if (alreadyInTeamCount > 0) {
          resultMessage += ` ${alreadyInTeamCount} number`
          if (alreadyInTeamCount !== 1) resultMessage += "s were"
          else resultMessage += " was"
          resultMessage += " already in this team."
        }
        if (failures.length > 0) {
          resultMessage += `\n\nFailed (${failures.length}):\n${failures.join("\n")}`
        }
        alert(resultMessage)
        if (failures.length === 0) this.addMembers()
      } catch (error) {
        const statusCode = error?.response?.status
        const responseData = error?.response?.data
        let serverMessage = ""

        if (typeof responseData === "string") {
          serverMessage = responseData.trim()
        }
        else if (responseData && typeof responseData === "object") {
          serverMessage = String(responseData.message || responseData.error || "").trim()
        }

        const statusText = statusCode ? ` (HTTP ${statusCode})` : ""
        const reasonText = serverMessage ? `\n\nReason: ${serverMessage}` : ""
        console.error("Adding team members failed", {
          status: statusCode,
          response: responseData,
          error
        })
        alert(`Adding members failed${statusText}.${reasonText}`)
      } finally {
        this.newMembersSubmitting = false
      }
    },
    getNewMemberStatusDisplay(member) {
      if (member.submissionStatus === "pending") return "Adding..."
      if (member.submissionStatus === "failed") return member.submissionError
      if (member.submissionStatus === "restored") return "Membership restored"
      if (member.submissionStatus === "added") return "Added to team"
      if (member.alreadyInTeam) return "Already in team"
      return member.isExisting ? "Existing user" : "New member"
    },
    getNewMemberStatusClass(member) {
      if (member.submissionStatus === "failed") return "text-danger"
      if (member.submissionStatus === "added" || member.submissionStatus === "restored") return "text-success"
      return member.alreadyInTeam ? "text-muted" : ""
    },
    getNewMemberAddError(error) {
      const statusCode = error?.response?.status
      let responseData = error?.response?.data
      if (typeof responseData === "string") {
        try { responseData = JSON.parse(responseData) } catch { /* Keep plain-text upstream errors. */ }
      }
      const reason = typeof responseData === "string"
        ? responseData.trim()
        : String(responseData?.message || responseData?.error || "").trim()
      const statusText = statusCode ? ` (HTTP ${statusCode})` : ""
      const conflictText = statusCode === 409
        ? " This may be a previously removed membership that needs to be restored on the server."
        : ""
      return `Adding failed${statusText}.${reason ? ` ${reason}` : " Please try again."}${conflictText}`
    },
    //TODO
    submitSingleLicense(user) {
      let now = Date.now()
      let email = firebase.auth().currentUser.email
      let name = email.split('@')[0].split('.')[0]
      name = name.charAt(0).toUpperCase() + name.slice(1)
      let comment = document.getElementById("newLicenseComment")
      let time = new Date(this.userLicenseDate)
      if (user.userdata == null) {
        user.userdata = this.buildPlaceholderTeamUserData({
          phoneNumber: user?.user?.phoneNumber || "",
          displayName: user?.user?.name || ""
        })
      }
      if (!Array.isArray(user.userdata.licenses)) {
        user.userdata.licenses = []
      }
      let body = {
        created : now,
        creator : name,
        comment : comment.value,
        valid : true,
        validUntil : time.getTime(),
        phoneNumber : user.userdata.cellnumber
      }
      let backendAPI = API_ENDPOINTS.TIW_API + "/rest/lic"
      axios.post(backendAPI, body).then((res) => {
        body.validuntil = body.validUntil
        user.userdata.licenses.push(body)
        this.syncMemberLongestLicense(user.userdata)
        alert("License added to "+user.userdata.cellnumber+" until "+this.userLicenseDate)
        this.togglenewlicense = !this.togglenewlicense
      })
    },
    addNotes(user) {
      let note = document.getElementById("userNoteInput")
      if (note.value != "") {
        let body = {
          name: "admin_note",
          created: Date.now(),
          data: { text: note.value },
          dataJsonStr: null,
        }
        let apiURL = API_ENDPOINTS.TIW_API + "/activity/" + user.userdata.cellnumber
        axios.post(apiURL, body).then((res) => {
          alert("Note has been added")
          document.getElementById("userNoteInput").value = ""
          user.userdata.notes.push(body)
        })
      }
    },

    //Adding Licenses To Team Members
    async activateTeamLicense(team) {
      //Basic Information
      let now = Date.now()
      let email = firebase.auth().currentUser.email
      let name = email.split('@')[0].split('.')[0]
      name = name.charAt(0).toUpperCase() + name.slice(1)

      //What Members
      let licenseTeam = []
      if (this.addlicenseschoice == "all" || this.addlicenseschoice == "needed") {
        licenseTeam = this.teamLicenseMemberRows
      }
      else licenseTeam = this.customlicense.slice()

      const selectedMemberCount = licenseTeam.length
      licenseTeam = licenseTeam.filter((member) => this.memberNeedsTeamLicense(member, team))
      const skippedMemberCount = selectedMemberCount - licenseTeam.length

      //Posting License
      let successCount = 0
      let failedCount = 0
      for(let i = 0; i < team.licenceCount && i < licenseTeam.length; i++){
        let member = licenseTeam[i]
        let memberData = this.ensureMemberUserdata(member)
        let body = {
          created : now,
          creator : name,
          comment : this.teamLicenseComment,
          valid: true,
          validUntil : team.validUntil,
          phoneNumber: member.user.phoneNumber
        }
        try {
          await this.postLicense(body)
          body.validuntil = body.validUntil
          memberData.licenses.push(body)
          this.syncMemberLongestLicense(memberData)
          successCount += 1
        }
        catch (error) {
          failedCount += 1
        }
      }

      const linkedSimsToUpdate = this.teamLicenseSimsToUpdate
      const simTargetDate = this.getTeamLicenseTargetDateValue(team)
      let simSuccessCount = 0
      let simFailedCount = 0

      if (simTargetDate.length > 0) {
        for (let i = 0; i < linkedSimsToUpdate.length; i += 1) {
          const sim = linkedSimsToUpdate[i]
          try {
            await this.updateTeamSimValidity(sim, simTargetDate)
            sim.validUntil = simTargetDate
            simSuccessCount += 1
          } catch (error) {
            simFailedCount += 1
          }
        }
      }

      if (failedCount === 0 && simFailedCount === 0) {
        const resultParts = []
        if (successCount > 0) resultParts.push(`licenses were added to ${successCount} member(s)`)
        if (skippedMemberCount > 0) resultParts.push(`${skippedMemberCount} member(s) already had the same or a longer license`)
        if (simSuccessCount > 0) resultParts.push(`${simSuccessCount} linked SIM(s) were updated`)
        alert(resultParts.length > 0 ? resultParts.join("; ") : "No member or linked SIM needs renewal.")
        this.AddLicenses()
        return
      }

      if (successCount > 0 || simSuccessCount > 0) {
        const successParts = []
        if (successCount > 0) successParts.push(`licenses were added to ${successCount} member(s)`)
        if (skippedMemberCount > 0) successParts.push(`${skippedMemberCount} member(s) already had the same or a longer license`)
        if (simSuccessCount > 0) successParts.push(`${simSuccessCount} linked SIM(s) were updated`)

        const failedParts = []
        if (failedCount > 0) failedParts.push(`${failedCount} member license update(s) failed`)
        if (simFailedCount > 0) failedParts.push(`${simFailedCount} linked SIM update(s) failed`)

        alert(`${successParts.join(" and ")}, but ${failedParts.join(" and ")}.`)
        return
      }

      if (simFailedCount > 0) {
        alert("Team license activation failed. Linked SIM updates also failed. Please try again.")
        return
      }

      alert("Team license activation failed. Please try again.")
    },
    async postLicense(body){
      let backendAPI = API_ENDPOINTS.TIW_API + "/rest/lic"
      return axios.post(backendAPI, body)
    },
    getCustomMemberIndex(member) {
      const phoneNumber = member?.user?.phoneNumber
      return this.customlicense.findIndex((customMember) => customMember?.user?.phoneNumber === phoneNumber)
    },
    isCustomMemberSelected(member) {
      return this.getCustomMemberIndex(member) !== -1
    },
    toggleCustomMemberSelection(member, isSelected) {
      const memberIndex = this.getCustomMemberIndex(member)

      if (isSelected) {
        if (memberIndex === -1) this.customlicense.push(member)
        return
      }

      if (memberIndex !== -1) this.customlicense.splice(memberIndex, 1)
    },

    //PUT REQUESTS__________________________________________________________________________
    submitNewTeamName(team) {
      let value = document.getElementById("newTeamNameInput")
      if(value.value == '') alert("Enter a new name!")
      else{
        let body = { 
          name: value.value,
          licenceCount: team.licenceCount
        }
        let backendAPI = API_ENDPOINTS.TIW_API + "/team/" + team.uuid + "/" + team.phoneNumber
        axios.put(backendAPI, body).then((res) => {
          alert("Team name changed to " + value.value)
          team.teamName = value.value
          team.name = value.value
          this.filterentries = this.entries
          this.defaultentries = this.entries
          this.paginateData(this.entries)
          this.allPages = $.array.pages(this.entries, this.currentEntries)
        })
      }
    },
    submitNewContactName(team) {
      let value = document.getElementById("newContactNameInput")
      if(value.value == '') alert("Enter a contact name!")
      else{
        let body = { 
          contactName: value.value,
          licenceCount: team.licenceCount
        }
        let backendAPI = API_ENDPOINTS.TIW_API + "/team/" + team.uuid + "/" + team.phoneNumber
        axios.put(backendAPI, body).then((res) => {
          alert("Contact name added")
          team.contactName = value.value
          this.filterentries = this.entries
          this.defaultentries = this.entries
          this.paginateData(this.entries)
          this.allPages = $.array.pages(this.entries, this.currentEntries)
        })
      }
    },
    submitNewContactEmail(team) {
      let value = document.getElementById("newContactEmailInput")
      if(value.value == '') alert("Enter a contact email!")
      else{
        let body = { 
          contactEmail: value.value,
          licenceCount: team.licenceCount
         }
        let backendAPI = API_ENDPOINTS.TIW_API + "/team/" + team.uuid + "/" + team.phoneNumber
        axios.put(backendAPI, body).then((res) => {
          alert("Contact email added")
          team.contactEmail = value.value
          this.filterentries = this.entries
          this.defaultentries = this.entries
          this.paginateData(this.entries)
          this.allPages = $.array.pages(this.entries, this.currentEntries)
        })
      }
    },
    submitNewLicenseAmount(team) {
      let value = document.getElementById("newLicenseAmountInput")
      value = parseInt(value.value)
      if(value == '') alert("Enter a license amount!")
      else{
        let body = { licenceCount: value }
        let backendAPI = API_ENDPOINTS.TIW_API + "/team/" + team.uuid + "/" + team.phoneNumber
        axios.put(backendAPI, body).then((res) => {
          alert("New licence count added!")
          team.licenceCount = value
          team.licenceCountmax = value
          team.licenceCountmin = value
          this.filterentries = this.entries
          this.defaultentries = this.entries
          this.paginateData(this.entries)
          this.allPages = $.array.pages(this.entries, this.currentEntries)
        })
      }
    },
    submitNewLicenseDate(team) {
      let date = new Date(this.teamLicenseDate)
      let value = date.getTime()
      let body = {
        validUntil: value,
        licenceCount: team.licenceCount
      }
      let backendAPI = API_ENDPOINTS.TIW_API + "/team/" + team.uuid + "/" + team.phoneNumber
      axios.put(backendAPI, body).then((res) => {
        alert("New license date added")
        team.validUntil = value
        team.validDate = this.teamLicenseDate
        this.filterentries = this.entries
        this.defaultentries = this.entries
        this.paginateData(this.entries)
        this.allPages = $.array.pages(this.entries, this.currentEntries)
      })
    },
    submitNewHuntCode(team) {
      const value = String(this.teamHuntCodeInput || '').trim()
      if(value == '') alert("Enter a hunt code!")
      else{
        let body = { 
          permanentHuntCode: value,
          licenceCount: team.licenceCount
         }
        let backendAPI = API_ENDPOINTS.TIW_API + "/team/" + team.uuid + "/" + team.phoneNumber
        axios.put(backendAPI, body).then((res) => {
          alert("Hunt code added")
          team.permanentHuntCode = value
          this.teamHuntCodeInput = value
          this.filterentries = this.entries
          this.defaultentries = this.entries
          this.paginateData(this.entries)
          this.allPages = $.array.pages(this.entries, this.currentEntries)
        })
      }
    },
    sanitizeHuntCodeTeamName(teamName) {
      const trimmedTeamName = typeof teamName === "string" ? teamName.trim() : ""
      if (!trimmedTeamName) return ""

      return trimmedTeamName
        .normalize("NFKD")
        .replace(/[\u0300-\u036f]/g, "")
        .replace(/\//g, "")
        .replace(/\s+/g, "_")
        .replace(/[^A-Za-z0-9_-]/g, "")
        .replace(/_+/g, "_")
        .replace(/^_+|_+$/g, "")
    },
    buildStaticHuntRequestUrl(sanitizedTeamName) {
      if (!sanitizedTeamName) return ""

      return "https://hunter-server.appspot.com/rest/hunt/create/statichunt" +
        `?creatorPhone=${encodeURIComponent(sanitizedTeamName)}` +
        `&creatorName=${encodeURIComponent(sanitizedTeamName)}` +
        "&imei=secret_imei_x"
    },
    async generateAndSaveHuntCode(team) {
      const teamName = String(team?.name || team?.teamName || "").trim()
      const sanitizedTeamName = this.sanitizeHuntCodeTeamName(teamName)
      const staticHuntUrl = this.buildStaticHuntRequestUrl(sanitizedTeamName)
      const teamSaveApi = API_ENDPOINTS.TIW_API + "/team/" + team.uuid + "/" + team.phoneNumber

      if (sanitizedTeamName.length === 0) {
        alert("Team name is missing!")
        return
      }

      this.isGeneratingHuntCode = true
      try {
        const response = await axios.get(staticHuntUrl)
        const pin = String(response?.data?.pin || "").trim()

        if (pin.length === 0) {
          throw new Error("Generated hunt code missing from response")
        }
        await axios.put(teamSaveApi, {
          permanentHuntCode: pin,
          licenceCount: team.licenceCount
        })

        this.teamHuntCodeInput = pin
        team.permanentHuntCode = pin
        this.filterentries = this.entries
        this.defaultentries = this.entries
        this.paginateData(this.entries)
        this.allPages = $.array.pages(this.entries, this.currentEntries)
        alert("Hunt code generated and saved")
      } catch (error) {
        const errorMessage =
          error?.response?.data?.message ||
          error?.response?.data?.error ||
          error?.message ||
          "Generating hunt code failed"
        alert(errorMessage)
      } finally {
        this.isGeneratingHuntCode = false
      }
    },
    submitPermission(team, member) {
      let perm = ""
      if (member.permission == "admin") {
        perm = "view"
        member.permission = "view"
      } else if (member.permission == "view") {
        perm = "admin"
        member.permission = "admin"
      } else {
        perm = "view"
        member.permission = "view"
      }
      let backendAPI = API_ENDPOINTS.TIW_API + "/team/" + team.uuid + "/permissions/" + member.uuid + "/" + team.phoneNumber
      let body = { 
        user: {
          phoneNumber:team.phoneNumber
        },
        permission: perm
      }
      axios.put(backendAPI, body).then((res) => {
      })
    },
    submitStatus(team, member) {
      let status
      if (member.fullMember == null) {
        member.fullMember = true
        status = true
      } else if (member.fullMember == false) {
        member.fullMember = true
        status = true
      } else {
        status = false
        member.fullMember = false
      }
      let backendAPI = API_ENDPOINTS.TIW_API + "/team/" + team.uuid + "/permissions/" + member.uuid + "/" + team.phoneNumber
      let body = { 
        user: {
          phoneNumber:team.phoneNumber
        },
        fullMember: status
      }
      axios.put(backendAPI, body).then((res) => {
      })
    },

    //DELETE REQUESTS__________________________________________________________________________
    submitDeleteTeam(team) {
      let conf = confirm("Do you want to delete this team?")
      let backendAPI = API_ENDPOINTS.TIW_API + "/team/"+team.uuid+"/"+team.phoneNumber
      if(conf){
        axios.delete(backendAPI).then((res) => {
          const entryCollections = new Set([this.allEntries, this.entries])
          entryCollections.forEach((collection) => {
            if (!Array.isArray(collection)) return
            for(let i = 0; i < collection.length; i++){
              if(collection[i].uuid == team.uuid){
                collection.splice(i, 1)
                break
              }
            }
          })
          this.filterentries = this.entries
          this.defaultentries = this.allEntries
          this.paginateData(this.entries)
          this.allPages = $.array.pages(this.entries, this.currentEntries)
          this.TogglePopup("teamsInfoTrigger")
          this.TogglePopup("changeTeamTrigger")
          setTimeout(() => {}, 1)
          alert("Team has been deleted")
        })
      }
    },
    submitDeleteMember(team, member) {
      let answer = confirm("are you sure you want to delete this user?")
      if (answer) {
        let backendAPI = API_ENDPOINTS.TIW_API + "/team/" + team.uuid + "/permissions/" + member.uuid + "/" + member.user.phoneNumber
        axios.delete(backendAPI).then((res) => {
          for (let i = 0; i < team.permissions.length; i++) {
            if (member.uuid == team.permissions[i].uuid) {
              if(team.permissions[i].fullMember) { 
                team.fullmembers--
                team.fullmembersmax--
                team.fullmembersmin--
              }
              else {
                team.othermembers--
                team.othermembersmax--
                team.othermembersmin--
              }
              team.permissions.splice(i, 1)
                team.members--
                team.membersmin--
                team.membersmax--
                break
            }
          }
          alert("Member has been deleted from team")
          this.paginateData(this.entries)
          this.allPages = $.array.pages(this.entries, this.currentEntries)
        })
      }
    },
    
    //FILTERS______________________________________________________________________________
    //MAIN FILTER FUNCTION
    filterByColumn() {
      this.resetSortIcon()
      this.currentPage = 1
      this.entries = this.defaultentries
      const filterCol = $.object.removeBy(this.col, "")
      let filterData = this.getCurrentEntries()
      if (Object.entries(filterCol).length >= 1) filterData = this.filter(filterCol)
      this.entries = filterData
      this.filterentries = this.entries
      this.resetSortLogic()
      this.paginateData(this.entries)
      this.allPages = $.array.pages(this.entries, this.currentEntries)
    },

    //FILTER FUNCTION HELP
    filter(filterObj) {
      let filteredArray = Array.from(this.getCurrentEntries())
      for (let [key, val] of Object.entries(filterObj, "", 0)) {
        const filterfromArr = filteredArray.filter((obj) => {
          if (key in obj) {
            //filtering strings
            if (!key.includes("min") && !key.includes("max")) {
              if (obj[key] == Number(val)) {
                return true
              } else if (
                obj[key] &&
                obj[key].toLowerCase().includes(val.toLowerCase())
              ) {
                return true
              }
            }
            
            //filtering integers and dates
            else if (key.includes("min") || key.includes("max")) {
              if (key.includes("Until")) {
                if (val.length >= 4) {
                  let date, yyyy, valms, value;
                  if (val.includes("-")) {
                    valms = val.split("-");
                    yyyy = valms[0];
                    if (valms[1] != "" && valms[1] != null) {
                      let mm;
                      if (valms[1].length < 2) {
                        mm = "0" + valms[1];
                      } else {
                        mm = valms[1];
                      }
                      if (valms[2] != "" && valms[2] != null) {
                        let dd;
                        if (valms[2].length < 2) {
                          dd = "0" + valms[2];
                        } else {
                          dd = valms[2];
                        }
                        date = new Date([yyyy, mm, dd].join("-"));
                      } else {
                        date = new Date([yyyy, mm].join("-"));
                      }
                    } else {
                      date = new Date(yyyy);
                    }
                  } else {
                    yyyy = val;
                    date = new Date(yyyy);
                  }
                  let object = Number(obj[key]);
                  if (key.includes("min")) {
                    value = date.getTime() - 7200000;
                    if (object >= value) {
                      return true;
                    }
                  } else if (key.includes("max")) {
                    value = date.getTime() + 79199999;
                    if (object <= value) {
                      return true;
                    }
                  }
                }
              }
              //integers
                let object = Number(obj[key])
                let value = Number(val)
                if (key.includes("min")) {
                  if (object >= value) {
                    return true
                  }
                } else if (key.includes("max")) {
                  if (object <= value) {
                    return true
                  }
                }
            }
          }
          return false
        })
        filteredArray = filterfromArr
      }
      return filteredArray
    },
    getValidUntilClass(validUntil) {
      if (validUntil == null || validUntil == 0) return ""
      if (validUntil < Date.now()) return "invalid"
      if (validUntil < Date.now() + 2629800000) return "invalidSoon"
      return ""
    },
    getTeamMemberGroup(member) {
      if (member == null) return 99
      if (member.permission == "owner") return 0
      if (member.fullMember === true) return 1
      return 2
    },
    getTeamMemberName(member) {
      if (member == null || member.user == null || member.user.name == null) return ""
      return String(member.user.name).trim()
    },
    getTeamMemberPhoneNumber(member) {
      if (member == null || member.user == null || member.user.phoneNumber == null) return ""
      return String(member.user.phoneNumber).trim()
    },
    sortMembersByName(members) {
      if (!Array.isArray(members)) return []

      return members.slice().sort((leftMember, rightMember) => {
        const leftName = this.getTeamMemberName(leftMember)
        const rightName = this.getTeamMemberName(rightMember)
        const byName = leftName.localeCompare(rightName, "et", { sensitivity: "base" })
        if (byName !== 0) return byName

        return this.getTeamMemberPhoneNumber(leftMember).localeCompare(this.getTeamMemberPhoneNumber(rightMember), "et", { sensitivity: "base" })
      })
    },
    getLinkedTeamSimBrandClass(brand) {
      const normalizedBrand = String(brand || "").trim()
      if (normalizedBrand === "Huntloc") return "sim-brand-huntloc"
      if (normalizedBrand === "Doglo") return "sim-brand-doglo"
      return ""
    },
    parseDateLikeValue(value, endOfDay = false) {
      if (value == null || value === 0) return null

      if (typeof value === "number" && Number.isFinite(value)) {
        const date = new Date(value)
        if (endOfDay) {
          date.setHours(23, 59, 59, 999)
        } else {
          date.setHours(0, 0, 0, 0)
        }
        return date.getTime()
      }

      const normalizedValue = String(value).trim()
      if (normalizedValue.length === 0) return null

      if (/^\d+$/.test(normalizedValue)) {
        const numericValue = Number(normalizedValue)
        if (!Number.isFinite(numericValue)) return null

        const date = new Date(numericValue)
        if (endOfDay) {
          date.setHours(23, 59, 59, 999)
        } else {
          date.setHours(0, 0, 0, 0)
        }
        return date.getTime()
      }

      const dateParts = normalizedValue.split("-").map((part) => Number(part))
      if (dateParts.length !== 3 || dateParts.some((part) => !Number.isFinite(part))) {
        return null
      }

      const [year, month, day] = dateParts
      const date = endOfDay
        ? new Date(year, month - 1, day, 23, 59, 59, 999)
        : new Date(year, month - 1, day, 0, 0, 0, 0)

      return date.getTime()
    },
    getTodayTimestamp() {
      const today = new Date()
      today.setHours(0, 0, 0, 0)
      return today.getTime()
    },
    getTeamLicenseTargetDateValue(team = this.team) {
      if (typeof team?.validDate === "string" && team.validDate.trim().length > 0) {
        return team.validDate.trim()
      }

      const validUntil = Number(team?.validUntil)
      if (Number.isFinite(validUntil) && validUntil > 0) {
        return this.formatCreatedDate(validUntil)
      }

      return ""
    },
    getTeamLicenseTargetTimestamp(team = this.team, endOfDay = false) {
      const validUntil = Number(team?.validUntil)
      if (Number.isFinite(validUntil) && validUntil > 0) {
        return this.parseDateLikeValue(validUntil, endOfDay)
      }

      return this.parseDateLikeValue(this.getTeamLicenseTargetDateValue(team), endOfDay)
    },
    getTeamSimValidUntilTimestamp(sim, endOfDay = false) {
      return this.parseDateLikeValue(sim?.validUntil, endOfDay)
    },
    getTeamSimValidUntilDisplay(sim) {
      if (sim?.validUntil == null || String(sim.validUntil).trim().length === 0) return "-"

      if (typeof sim.validUntil === "number" || /^\d+$/.test(String(sim.validUntil).trim())) {
        return this.formatCreatedDate(Number(sim.validUntil))
      }

      return String(sim.validUntil).trim()
    },
    getNormalizedTeamSimStatus(sim) {
      return String(sim?.status || '').trim().toLowerCase()
    },
    isInactiveTeamSim(sim) {
      const status = this.getNormalizedTeamSimStatus(sim)
      return status === 'stopped' || status === 'closed'
    },
    getLinkedTeamSimStatusClass(sim) {
      const status = this.getNormalizedTeamSimStatus(sim)
      if (status === 'stopped') return 'team-sim-status-stopped'
      if (status === 'closed') return 'team-sim-status-closed'
      return ''
    },
    getLinkedTeamSimValidUntilClass(sim) {
      const validUntil = this.getTeamSimValidUntilTimestamp(sim, true)
      if (!Number.isFinite(validUntil)) return ''

      const todayStart = new Date()
      todayStart.setHours(0, 0, 0, 0)
      const expiresSoonEnd = new Date(todayStart)
      expiresSoonEnd.setDate(expiresSoonEnd.getDate() + 14)
      expiresSoonEnd.setHours(23, 59, 59, 999)

      if (validUntil < todayStart.getTime()) return 'sim-valid-expired'
      if (validUntil <= expiresSoonEnd.getTime()) return 'sim-valid-soon'
      return ''
    },
    getTeamSimLicenseCellClass(sim) {
      const validUntil = this.getTeamSimValidUntilTimestamp(sim, true)
      if (!Number.isFinite(validUntil)) return "invalid"
      if (validUntil < Date.now()) return "invalid"
      if (validUntil < Date.now() + 2629800000) return "invalidSoon"

      const currentValidityStart = this.getTeamSimValidUntilTimestamp(sim, false)
      const teamTargetTimestamp = this.getTeamLicenseTargetTimestamp(this.team, false)
      if (Number.isFinite(currentValidityStart) && Number.isFinite(teamTargetTimestamp) && currentValidityStart < teamTargetTimestamp) {
        return "team-license-before-team"
      }

      return ""
    },
    getTeamSimExtensionDays(sim) {
      const targetTimestamp = this.getTeamLicenseTargetTimestamp(this.team, false)
      if (!Number.isFinite(targetTimestamp)) return 0

      const todayTimestamp = this.getTodayTimestamp()
      const currentTimestamp = this.getTeamSimValidUntilTimestamp(sim, false)
      const effectiveCurrentTimestamp = Number.isFinite(currentTimestamp)
        ? Math.max(currentTimestamp, todayTimestamp)
        : todayTimestamp

      const diffDays = (targetTimestamp - effectiveCurrentTimestamp) / DAY_MS
      if (!Number.isFinite(diffDays) || diffDays <= 0) return 0

      return diffDays
    },
    getTeamSimExtensionYearsDisplay(sim) {
      return (this.getTeamSimExtensionDays(sim) / 365).toFixed(3)
    },
    shouldExtendTeamSim(sim) {
      return !this.isInactiveTeamSim(sim) && this.getTeamSimExtensionDays(sim) > 0
    },
    async updateTeamSimValidity(sim, validUntil) {
      if (this.isInactiveTeamSim(sim)) {
        throw new Error('Stopped and closed SIMs cannot be renewed')
      }
      const payload = {
        ...sim,
        validUntil
      }
      const backendAPI = API_ENDPOINTS.TIW_API + "/sim/"
      return axios.put(backendAPI, payload)
    },
    getTeamMemberLastGroupDisplay(member) {
      const memberData = member?.userdata
      if (memberData?.last_joined_date) return memberData.last_joined_date
      if (!memberData?.last_joined) return "None"

      const lastJoined = new Date(memberData.last_joined)
      return Number.isNaN(lastJoined.getTime()) ? "None" : this.formatCreatedDate(lastJoined)
    },
    getTeamMemberLicenseDisplay(member) {
      const lastLicense = this.getMemberLastLicenseTimestamp(member)
      return lastLicense > 0 ? this.formatCreatedDate(lastLicense) : ""
    },
    getMemberLongestLicense(member) {
      const memberData = this.ensureMemberUserdata(member)
      return getLongestValidLicense(memberData.licenses)
    },
    getMemberLastLicenseTimestamp(member) {
      const memberData = this.ensureMemberUserdata(member)
      const longestLicenseTimestamp = getLicenseValidUntilTimestamp(this.getMemberLongestLicense(member))
      const storedLastLicense = Number(memberData.last_license)
      const validStoredLastLicense = Number.isFinite(storedLastLicense) ? storedLastLicense : 0
      const storedLastLicenseDate = this.parseDateLikeValue(memberData.last_license_date, false)
      const validStoredLastLicenseDate = Number.isFinite(storedLastLicenseDate) ? storedLastLicenseDate : 0

      if (!Number.isFinite(longestLicenseTimestamp)) {
        return Math.max(validStoredLastLicense, validStoredLastLicenseDate)
      }
      return Math.max(longestLicenseTimestamp, validStoredLastLicense, validStoredLastLicenseDate)
    },
    syncMemberLongestLicense(memberData) {
      if (!memberData) return

      const longestLicense = getLongestValidLicense(memberData.licenses)
      const longestLicenseTimestamp = getLicenseValidUntilTimestamp(longestLicense)
      if (!Number.isFinite(longestLicenseTimestamp)) return

      memberData.last_license = longestLicenseTimestamp
      memberData.last_license_date = this.formatCreatedDate(longestLicenseTimestamp)
    },
    memberNeedsTeamLicense(member, team = this.team) {
      const teamTargetTimestamp = this.getTeamLicenseTargetTimestamp(team, false)
      if (!Number.isFinite(teamTargetTimestamp)) return false
      return this.getMemberLastLicenseTimestamp(member) < teamTargetTimestamp
    },
    getTeamLicenseEligibilityDisplay(member) {
      return this.memberNeedsTeamLicense(member) ? "Will renew" : "Already covered"
    },
    getTeamLicenseEligibilityClass(member) {
      return this.memberNeedsTeamLicense(member)
        ? "team-license-eligibility team-license-eligibility-renew"
        : "team-license-eligibility team-license-eligibility-current"
    },
    getTeamLicenseCellDisplay(member) {
      const lastLicense = this.getMemberLastLicenseTimestamp(member)
      return lastLicense > 0 ? this.formatCreatedDate(lastLicense) : "-"
    },
    getTeamLicenseCellClass(member) {
      const lastLicense = this.getMemberLastLicenseTimestamp(member)
      if (lastLicense <= 0) return "invalid"
      if (lastLicense < new Date().getTime()) return "invalid"
      if (lastLicense < (new Date().getTime() + 2629800000)) return "invalidSoon"
      const teamTargetTimestamp = this.getTeamLicenseTargetTimestamp(this.team, false)
      if (Number.isFinite(teamTargetTimestamp) && lastLicense < teamTargetTimestamp) return "team-license-before-team"
      return ""
    },
    getDefaultTeamLicenseComment() {
      const teamName = String(this.team?.teamName || this.team?.name || "").trim()
      const currentYear = new Date().getFullYear()
      return teamName.length > 0 ? `${teamName} ${currentYear}` : String(currentYear)
    },
    resetNewMembersState() {
      this.newMembersInput = ""
      this.newMembersPreview = []
      this.newMembersChecked = false
      this.newMembersSubmitting = false
    },
    resetNewMembersPreview() {
      this.newMembersPreview = []
      this.newMembersChecked = false
    },
    sanitizeNewMembersInput(inputValue) {
      return String(inputValue ?? "")
        .replace(/\r\n?|[\u0085\u2028\u2029]/g, "\n")
        .replace(/[^+0-9\n]/g, "")
    },
    updateNewMembersInput(event) {
      const cleanInput = this.sanitizeNewMembersInput(event.target.value)
      if (event.target.value !== cleanInput) event.target.value = cleanInput
      this.newMembersInput = cleanInput
      this.resetNewMembersPreview()
    },
    normalizeNewMemberPhoneNumber(phoneNumber) {
      let normalizedPhoneNumber = String(phoneNumber ?? "").replace(/[^+0-9]/g, "")
      if (!/^\+?[0-9]+$/.test(normalizedPhoneNumber)) return ""
      if (!normalizedPhoneNumber.startsWith("+")) {
        normalizedPhoneNumber = `+${normalizedPhoneNumber}`
      }
      return normalizedPhoneNumber
    },
    parseNewMembersInput(inputValue) {
      const lines = this.sanitizeNewMembersInput(inputValue).split("\n")
      const uniquePhoneNumbers = []
      const seenPhoneNumbers = new Set()

      for (const line of lines) {
        const normalizedPhoneNumber = this.normalizeNewMemberPhoneNumber(line)
        if (normalizedPhoneNumber.length === 0 || seenPhoneNumbers.has(normalizedPhoneNumber)) continue
        seenPhoneNumbers.add(normalizedPhoneNumber)
        uniquePhoneNumbers.push(normalizedPhoneNumber)
      }

      return uniquePhoneNumbers
    },
    getLoadedUsersCollection() {
      if (Array.isArray(this.store?.state?.users)) return this.store.state.users
      if (Array.isArray(this.$store?.state?.users)) return this.$store.state.users
      if (Array.isArray(this.users)) return this.users
      return []
    },
    async ensureUsersLoadedForTeamMembers() {
      let users = this.getLoadedUsersCollection()
      const usersLoaded = Boolean(this.store?.state?.usersLoaded || this.$store?.state?.usersLoaded)
      if (users.length > 0 || usersLoaded) return users

      const storeInstance = this.$store?.dispatch ? this.$store : this.store
      if (storeInstance?.dispatch) {
        await storeInstance.dispatch("loadUsers")
      }

      users = this.getLoadedUsersCollection()
      if (Array.isArray(users)) {
        this.users = users
      }
      return users
    },
    findExistingUserByPhoneNumber(phoneNumber, users) {
      if (!Array.isArray(users)) return null
      const normalizedPhoneNumber = this.normalizeNewMemberPhoneNumber(phoneNumber)
      if (!normalizedPhoneNumber) return null

      for (const user of users) {
        const userPhoneNumber = this.normalizeNewMemberPhoneNumber(user?.cellnumber)
        if (userPhoneNumber === normalizedPhoneNumber) {
          return user
        }
      }

      return null
    },
    buildPlaceholderTeamUserData(previewMember) {
      const manualName = String(previewMember?.manualName || "").trim()
      const displayName = String(previewMember?.displayName || "").trim()
      return {
        name: manualName || displayName || "",
        cellnumber: previewMember?.phoneNumber || "",
        email: "",
        created: null,
        created_date: "",
        last_joined: null,
        last_joined_date: "",
        created_hunts: 0,
        all_hunts: 0,
        last_license: 0,
        last_license_date: "",
        licenses: [],
        devices: [],
        notes: [],
        teamsinfo: []
      }
    },
    ensureMemberUserdata(member) {
      if (member == null) {
        return this.buildPlaceholderTeamUserData({})
      }

      if (member.userdata == null || typeof member.userdata !== "object" || Array.isArray(member.userdata)) {
        member.userdata = this.buildPlaceholderTeamUserData({
          phoneNumber: member?.user?.phoneNumber || "",
          displayName: member?.user?.name || ""
        })
      }

      if (!Array.isArray(member.userdata.licenses)) {
        member.userdata.licenses = []
      }
      if (!Array.isArray(member.userdata.teamsinfo)) {
        member.userdata.teamsinfo = []
      }
      if (member.userdata.last_license == null || Number.isNaN(Number(member.userdata.last_license))) {
        member.userdata.last_license = 0
      }
      if (member.userdata.last_license_date == null) {
        member.userdata.last_license_date = ""
      }

      return member.userdata
    },
    applyNewTeamMember(team, member, previewMember) {
      const resolvedMember = member || {}
      if (resolvedMember.user == null) {
        resolvedMember.user = {}
      }

      if (!resolvedMember.user.phoneNumber) {
        resolvedMember.user.phoneNumber = previewMember.phoneNumber
      }

      if (!resolvedMember.user.name) {
        const manualName = String(previewMember.manualName || "").trim()
        if (manualName.length > 0) {
          resolvedMember.user.name = manualName
        }
        else if (previewMember.displayName) {
          resolvedMember.user.name = previewMember.displayName
        }
      }

      if (resolvedMember.permission == null) {
        resolvedMember.permission = "view"
      }
      if (resolvedMember.fullMember == null) {
        resolvedMember.fullMember = true
      }

      resolvedMember.userdata = previewMember.isExisting && previewMember.existingUser != null
        ? previewMember.existingUser
        : this.buildPlaceholderTeamUserData(previewMember)

      team.fullmembers = Number(team.fullmembers || 0) + 1
      team.fullmembersmin = Number(team.fullmembersmin || 0) + 1
      team.fullmembersmax = Number(team.fullmembersmax || 0) + 1
      team.members = Number(team.members || 0) + 1
      team.membersmin = Number(team.membersmin || 0) + 1
      team.membersmax = Number(team.membersmax || 0) + 1
      team.permissions.push(resolvedMember)
    },
    getTeamMemberAllGroupsDisplay(member) {
      if (member == null || member.userdata == null || member.userdata.all_hunts == null) return 0
      return member.userdata.all_hunts
    },
    getPaidByTeams(member) {
      const phoneNumber = member?.user?.phoneNumber
      const availableTeams = Array.isArray(this.allEntries) && this.allEntries.length > 0 ? this.allEntries : this.entries
      if (phoneNumber == null || !Array.isArray(availableTeams)) return []

      const currentTeamUuid = this.team?.uuid
      const paidTeams = []

      for (const team of availableTeams) {
        if (team?.uuid === currentTeamUuid || !Array.isArray(team?.permissions)) continue
        for (const permission of team.permissions) {
          if (permission?.user?.phoneNumber === phoneNumber && permission?.fullMember === true) {
            const teamName = team.teamName || team.name || ""
            if (teamName && !paidTeams.includes(teamName)) {
              paidTeams.push(teamName)
            }
            break
          }
        }
      }

      return paidTeams.sort((leftTeam, rightTeam) => leftTeam.localeCompare(rightTeam, "et", { sensitivity: "base" }))
    },
    getPaidByTeamsDisplay(member) {
      const paidTeams = this.getPaidByTeams(member)
      if (paidTeams.length === 0) return "-"
      return paidTeams.join(", ")
    },
    getPaidByTeamsClass(member) {
      const paidTeams = this.getPaidByTeams(member)
      if (member?.fullMember === true && paidTeams.length > 0) return "double-paid-team"
      return ""
    },
    sortTeamPermissionsForDisplay(permissions) {
      if (!Array.isArray(permissions)) return []
      return permissions.slice().sort((leftMember, rightMember) => {
        let leftGroup = this.getTeamMemberGroup(leftMember)
        let rightGroup = this.getTeamMemberGroup(rightMember)
        if (leftGroup != rightGroup) return leftGroup - rightGroup

        let leftName = this.getTeamMemberName(leftMember)
        let rightName = this.getTeamMemberName(rightMember)
        let byName = leftName.localeCompare(rightName, "et", { sensitivity: "base" })
        if (byName != 0) return byName

        let leftNumber = leftMember?.user?.phoneNumber ?? ""
        let rightNumber = rightMember?.user?.phoneNumber ?? ""
        return String(leftNumber).localeCompare(String(rightNumber), "et", { sensitivity: "base" })
      })
    },
    getTeamMemberRowClass(index) {
      if (index === 0) return ""
      let members = this.teamMemberRows
      if (members.length <= index) return ""
      if (this.getTeamMemberGroup(members[index - 1]) !== this.getTeamMemberGroup(members[index])) {
        return "team-member-divider"
      }
      return ""
    },
    getTeamPaidClass(team) {
      if (team == null) return ""
      let teamPaidCount = Number(team.fullmembers)
      let licenseCount = Number(team.licenceCount)
      if (!Number.isFinite(teamPaidCount) || !Number.isFinite(licenseCount)) return ""
      if (teamPaidCount > licenseCount) return "invalid"
      return ""
    },
    formatCsvCell(value) {
      if (value == null) return '""'
      let text = String(value)
      let escaped = text.replace(/"/g, '""')
      return `"${escaped}"`
    },
    buildTeamMembersCsv() {
      const rows = []
      const headers = ["#", "Name", "Cellnumber", "Role", "Team pays", "Paid by team", "License", "All Groups", "Last group"]
      rows.push(headers.join(";"))

      for (const [index, member] of this.teamMemberRows.entries()) {
        const values = [
          index + 1,
          this.getTeamMemberName(member),
          this.getTeamMemberPhoneNumber(member),
          member?.permission ?? "",
          member?.fullMember ?? "",
          this.getPaidByTeamsDisplay(member),
          this.getTeamMemberLicenseDisplay(member),
          this.getTeamMemberAllGroupsDisplay(member),
          this.getTeamMemberLastGroupDisplay(member)
        ]
        rows.push(values.map((value) => this.formatCsvCell(value)).join(";"))
      }

      return rows.join("\n")
    },
    downloadTeamMembersCsv() {
      let csv = "\uFEFF" + this.buildTeamMembersCsv()
      const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" })
      const url = window.URL.createObjectURL(blob)
      const a = document.createElement("a")
      let teamName = this.team?.teamName || this.team?.name || "Team"
      teamName = String(teamName).replace(/[<>:\"/\\|?*\x00-\x1F]/g, "_")
      a.setAttribute("hidden", "")
      a.setAttribute("href", url)
      a.setAttribute("download", `${teamName}_members.csv`)
      document.body.appendChild(a)
      a.click()
      document.body.removeChild(a)
      window.URL.revokeObjectURL(url)
    },
    formatCreatedDate(created) {
      if (created == null || created == 0) return ""
      let date = new Date(created)
      let y = date.getFullYear()
      let m = ("0" + (date.getMonth() + 1)).slice(-2)
      let d = ("0" + date.getDate()).slice(-2)
      return y + "-" + m + "-" + d
    },
    formatTeamSettingsDate(value) {
      if (value == null || value === "" || value === 0) return "Not set"

      const isoDate = String(value).match(/^(\d{4})-(\d{2})-(\d{2})$/)
      if (isoDate) return `${isoDate[3]}.${isoDate[2]}.${isoDate[1]}`

      const date = new Date(value)
      if (Number.isNaN(date.getTime())) return String(value)

      const day = ("0" + date.getDate()).slice(-2)
      const month = ("0" + (date.getMonth() + 1)).slice(-2)
      return `${day}.${month}.${date.getFullYear()}`
    },
    

    //SORTING______________________________________________________________________________
    sortByColumn(column) {
      let sortedEntries = this.getCurrentEntries()
      let sortedColumn = this.sortcol[column]
      if (sortedColumn === "") {
        this.sortcol[column] = "asc"
        if (column == "phoneNumber") this.sortnumber = "asc"
        else if (column == "ownerName") this.sortownername = "asc"
        else if (column == "teamName") this.sortteamname = "asc"
        else if (column == "created_date") this.sortcreated = "asc"
        else if (column == "members") this.sortmembers = "asc"
        else if (column == "fullmembers") this.sortfullmembers = "asc"
        else if (column == "othermembers") this.sortothermembers = "asc"
        else if (column == "licenceCount") this.sortlicensescount = "asc"
        else if (column == "validUntil") this.sortvaliduntil = "asc"
        sortedEntries = $.array.sortBy(this.getCurrentEntries(), column, "asc")
        this.entries = sortedEntries }
      else if (sortedColumn === "asc") {
        this.sortcol[column] = "desc"
        if (column == "phoneNumber") this.sortnumber = "desc"
        else if (column == "ownerName") this.sortownername = "desc"
        else if (column == "teamName") this.sortteamname = "desc"
        else if (column == "created_date") this.sortcreated = "desc"
        else if (column == "members") this.sortmembers = "desc"
        else if (column == "fullmembers") this.sortfullmembers = "desc"
        else if (column == "othermembers") this.sortothermembers = "desc"
        else if (column == "licenceCount") this.sortlicensescount = "desc"
        else if (column == "validUntil") this.sortvaliduntil = "desc"
        sortedEntries = $.array.sortBy(this.getCurrentEntries(), column, "desc")
        this.entries = sortedEntries }
      else if (sortedColumn === "desc") {
        this.sortcol[column] = ""
        if (column == "phoneNumber") this.sortnumber = "default"
        else if (column == "ownerName") this.sortownername = "default"
        else if (column == "teamName") this.sortteamname = "default"
        else if (column == "created_date") this.sortcreated = "default"
        else if (column == "members") this.sortmembers = "default"
        else if (column == "fullmembers") this.sortfullmembers = "default"
        else if (column == "othermembers") this.sortothermembers = "default"
        else if (column == "licenceCount") this.sortlicensescount = "default"
        else if (column == "validUntil") this.sortvaliduntil = "default"
        this.entries = this.filterentries }
      this.paginateData(this.entries)
    },

    //RESETS______________________________________________________________________________________
    resetTeams() {
      this.resetSortIcon()
      this.resetSortLogic()
      this.entries = this.defaultentries
      this.filterentries = this.defaultentries
      this.currentPage = 1
      this.searchInput = ""
      this.col = {
        teamName: "",
        ownerName: "",
        phoneNumber: "",
        created_date: "",
        membersmin: "",
        membersmax: "",
        fullmembers: "",
        othermembers: "",
        licenceCount: "",
        validUntil: ""
      },
      this.paginateEntries()
    },
    resetSortIcon() {
      this.sortnumber = "default"
      this.sortownername = "default"
      this.sortteamname= "default"
      this.sortcreated = "default"
      this.sortmembers = "default"
      this.sortfullmembers = "default"
      this.sortothermembers = "default"
      this.sortlicensescount = "default"
      this.sortvaliduntil = "default"
    },
    resetSortLogic() {
      this.sortcol["phoneNumber"] = ""
      this.sortcol["ownerName"] = ""
      this.sortcol["teamName"] = ""
      this.sortcol["created_date"] = ""
      this.sortcol["members"] = ""
      this.sortcol["fullmembers"] = ""
      this.sortcol["othermembers"] = ""
      this.sortcol["licenceCount"] = ""
      this.sortcol["validUntil"] = ""
    },

    //PAGINATION ETC MISC
    
    paginateEntries() {
      if (this.searchInput.length >= 1) {
        this.searchEntries = $.array.search(this.entries, this.searchInput)
        this.paginateData(this.searchEntries)
      } else {
        this.searchEntries = []
        this.paginateData(this.entries)
      }
    },
    paginateEvent(page) {
      this.currentPage = page
      this.paginateEntries()
    },
    searchEvent() {
      this.resetSortIcon()
      this.resetSortLogic()
      this.currentPage = 1
      this.paginateEntries()
    },
    paginateData(data) {
      this.filteredEntries = $.array.paginate(data, this.currentPage, this.currentEntries)
      this.allPages = $.array.pages(data, this.currentEntries)
    },
    getCurrentEntries() {
      return this.searchEntries.length <= 0 ? this.entries : this.searchEntries
    },
    async loginPortal(user) {
      const pin = String(this.portalPIN || "").trim()
      const cell = String(user?.userdata?.cellnumber || "").trim()

      if (!pin) {
        alert("Please enter PIN.")
        return
      }

      if (!cell) {
        alert("User phone number is missing.")
        return
      }

      const apiURL = API_ENDPOINTS.TIW_API + "/portal-auth/" + encodeURIComponent(cell) + "/" + encodeURIComponent(pin)
      try {
        await axios.get(apiURL)
        alert("User signed in")
        this.portalPIN = ""
      } catch (error) {
        const message = error?.response?.data?.message || error?.response?.data?.error || "Portal login failed."
        alert(message)
      }
    },
  },
};
</script>

<style scoped>
.numberSearch {
  display: flex;
}
.bold {
  font-weight: bold;
}
html,
body {
  max-width: 100%;
}
th,
td,
tr,
select,
input,
body {
  font-size: 10px;
}
th {
  font-weight: normal;
}
button {
  font-size: 10px;
}
.table-filter-label,
.table-column-toggle {
  font-size: 10px;
}
.table-column-toggle {
  display: inline-flex;
  align-items: center;
  gap: 6px;
}
.teams-list-view { padding: 4px 18px 18px; color: #202629; }
.teams-list-header { display: flex; align-items: flex-start; justify-content: space-between; gap: 16px; margin: 0 -18px 18px; padding: 20px 22px; border-left: 4px solid #f56600; border-radius: 0 0 9px 9px; background: #202629; color: #fff; }
.teams-list-header h1 { margin: 0; font-size: 22px; font-weight: 700; }
.teams-list-toolbar { display: flex; align-items: center; flex-wrap: wrap; gap: 12px; margin-bottom: 12px; padding: 12px; border: 1px solid #e1e5e6; border-radius: 9px; background: #fbfcfc; }
.teams-list-page-size { display: flex; align-items: center; gap: 7px; }
.teams-list-page-size label { color: #40545e; font-size: 10px; font-weight: 700; text-transform: uppercase; }
.teams-list-page-size select { width: 64px; font-size: 10px; font-weight: 700; }
.teams-list-header-updated { display: flex; align-items: center; gap: 6px; color: #c8d0d3; font-size: 11px; font-style: italic; }
.teams-list-header-loading { display: inline-flex; }
.teams-list-header-loading .spinner-border { width: 11px; height: 11px; border-width: 2px; }
.teams-list-legend { color: #687277; font-size: 10px; }
.teams-list-actions { display: flex; flex: 1; flex-wrap: wrap; justify-content: flex-end; gap: 7px; }
.teams-list-actions .btn { margin: 0; font-size: 10px; }
.teams-list-secondary { border: 1px solid #d7dfe2; background: #fff; color: #202629; }
.teams-list-secondary:hover { border-color: #f56600; color: #f56600; }
.teams-list-search { width: 180px; height: 29px; color: #202629; }
.teams-list-columns { display: flex; align-items: center; flex-wrap: wrap; gap: 6px 12px; margin-bottom: 12px; padding: 10px 12px; border: 1px solid #e1e5e6; border-radius: 9px; background: #fbfcfc; }
.teams-list-columns .table-filter-label { margin: 0; color: #40545e; font-weight: 700; text-transform: uppercase; }
.teams-list-table-wrap { overflow-x: auto; border: 1px solid #e1e5e6; border-radius: 9px; background: #fff; }
.teams-data-table { min-width: 1100px; margin-bottom: 0; }
.teams-data-table thead { background: #f1f4f5; }
.teams-data-table th, .teams-data-table td { padding: 9px 10px; vertical-align: middle; border-color: #e1e5e6; }
.teams-data-table thead th { color: #40545e; font-size: 10px; font-weight: 700; letter-spacing: .03em; text-transform: uppercase; }
.teams-data-table tbody tr:last-child > * { border-bottom: 0; }
@media (max-width: 700px) { .teams-list-view { padding: 4px 10px 12px; } .teams-list-header { margin: 0 -10px 14px; padding: 16px; } .teams-list-actions { justify-content: flex-start; } .teams-list-search { width: 100%; } }
.team-settings { width: min(100%, 560px); color: #202629; }
.team-settings-header { margin-bottom: 18px; }
.team-settings-eyebrow { margin: 0 0 3px; color: #f56600; font-size: 10px; font-weight: 700; letter-spacing: .08em; text-transform: uppercase; }
.team-settings h5 { margin: 0; font-size: 19px; font-weight: 700; }
.team-settings-header > p:last-child { margin: 5px 0 0; color: #6c757d; font-size: 11px; }
.team-settings-card { margin-bottom: 10px; padding: 12px; background: #fbfcfc; border: 1px solid #e1e5e6; border-left: 3px solid #f56600; border-radius: 9px; }
.team-settings-card-header { display: flex; flex-wrap: wrap; align-items: baseline; justify-content: flex-start; gap: 4px 7px; margin-bottom: 8px; }
.team-settings-card-header label { color: #202629; font-size: 11px; font-weight: 700; }
.team-settings-card-header span { max-width: 100%; overflow: hidden; color: #687277; font-size: 11px; text-overflow: ellipsis; white-space: nowrap; }
.team-settings-control-row { display: flex; gap: 7px; align-items: stretch; }
.team-settings-control-row .form-control { min-width: 0; }
.team-settings-control-row .form-control:focus { border-color: #f56600; box-shadow: 0 0 0 .15rem rgba(245, 102, 0, .16); }
.team-settings-control-row .btn { flex: 0 0 auto; }
.team-settings-save { border: 1px solid #f56600; background: #f56600; color: #fff; font-size: 10px; }
.team-settings-save:hover { border-color: #d95700; background: #d95700; color: #fff; }
.team-settings-generate { border: 1px solid #202629; color: #202629; font-size: 10px; }
.team-settings-generate:hover { background: #202629; color: #fff; }
.team-settings-hunt-code .form-control { min-width: 80px; }
.team-settings-hint { margin: 7px 0 0; color: #6c757d; font-size: 10px; }
.team-settings-danger { display: flex; align-items: center; justify-content: space-between; gap: 16px; margin-top: 18px; padding: 12px; border: 1px solid #ead9d2; border-radius: 9px; background: #fffaf7; }
.team-settings-danger h6 { margin: 0 0 3px; color: #9b3131; font-size: 12px; font-weight: 700; }
.team-settings-danger p { margin: 0; color: #8d6262; font-size: 10px; }
.team-settings-delete-button { flex: 0 0 auto; border: 1px solid #ad3c3c; color: #ad3c3c; font-size: 10px; }
.team-settings-delete-button:hover { background: #ad3c3c; color: #fff; }
.team-details { width: min(96vw, 1180px); padding: 4px; color: #202629; }
.team-details-header { margin-bottom: 20px; padding: 20px; border-left: 4px solid #f56600; border-radius: 9px; background: #202629; color: #fff; }
.team-details-header h2 { margin: 0; font-size: 22px; font-weight: 700; }
.team-details-created { margin: 5px 0 14px; color: #c8d0d3; font-size: 11px; font-style: italic; }
.team-details-actions { display: flex; flex-wrap: wrap; gap: 8px; }
.team-details-secondary { border: 1px solid #d7dfe2; background: #fff; color: #202629; font-size: 10px; }
.team-details-header .team-details-secondary { border-color: #67767d; background: transparent; color: #fff; }
.team-details-header .team-details-secondary:hover { border-color: #fff; background: #fff; color: #202629; }
.team-details-section { margin-top: 18px; padding: 14px; border: 1px solid #e1e5e6; border-radius: 9px; background: #fbfcfc; }
.team-details-section-heading { display: flex; align-items: center; justify-content: space-between; gap: 12px; margin-bottom: 10px; }
.team-details-section-heading h3 { margin: 0; color: #202629; font-size: 14px; font-weight: 700; }
.team-details-section-heading h3 span { color: #687277; font-weight: normal; }
.team-details-section-note { margin: -2px 0 10px; color: #687277; font-size: 10px; }
.team-details-inactive-sims { border-color: #ead9d2; background: #fffaf7; }
.team-details-summary { display: grid; grid-template-columns: repeat(auto-fit, minmax(145px, 1fr)); gap: 8px; }
.team-details-summary > div { min-width: 0; padding: 10px; border-left: 3px solid #f56600; border-radius: 6px; background: #fff; }
.team-details-summary span, .team-details-summary strong { display: block; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
.team-details-summary span { margin-bottom: 3px; color: #687277; font-size: 10px; }
.team-details-summary strong { color: #202629; font-size: 11px; }
.team-details-table-wrap { overflow-x: auto; border: 1px solid #e1e5e6; border-radius: 7px; background: #fff; }
.team-details-table { min-width: 950px; margin-bottom: 0; }
.team-details-table thead { background: #f1f4f5; }
.team-details-table th, .team-details-table td { padding: 9px 10px; vertical-align: middle; }
.team-details-table thead th { color: #40545e; font-size: 10px; font-weight: 700; letter-spacing: .03em; text-transform: uppercase; }
.team-details-user-button { padding: 2px 4px; color: #f56600; }
.team-details-user-button:hover { color: #d95700; }
.team-details-sim-button { padding: 2px 4px; color: #202629; }
.team-details-sim-button:hover { color: #f56600; }
.team-sim-status-stopped,
.team-sim-status-closed,
.sim-valid-expired,
.sim-valid-soon,
.team-sim-renewal-excluded { display: inline-block; min-width: 72px; padding: 2px 6px; border-radius: 999px; color: #202629; text-align: center; }
.team-sim-status-stopped,
.sim-valid-soon { background: #ffe066; }
.team-sim-status-closed,
.sim-valid-expired { background: salmon; }
.team-sim-renewal-excluded { background: #e5e9eb; color: #59666d; }
.team-license-dialog { width: min(96vw, 980px); padding: 4px; color: #202629; }
.team-license-dialog .team-details-table { width: 100%; min-width: 0; }
.team-license-header { margin-bottom: 20px; padding: 20px; border-left: 4px solid #f56600; border-radius: 9px; background: #202629; color: #fff; }
.team-license-header h2 { margin: 0; font-size: 22px; font-weight: 700; }
.team-license-header p { margin: 5px 0 0; color: #c8d0d3; font-size: 11px; font-style: italic; }
.team-license-comment-label { display: block; margin: 12px 0 5px; color: #202629; font-size: 11px; font-weight: 700; }
.team-license-safety-note { margin: 10px 0 0; color: #687277; font-size: 10px; }
.team-license-comment { max-width: 520px; }
.team-license-comment:focus { border-color: #f56600; box-shadow: 0 0 0 .15rem rgba(245, 102, 0, .16); }
.team-license-actions { display: flex; flex-wrap: wrap; align-items: center; justify-content: space-between; gap: 10px; margin-top: 12px; }
.team-license-choice-buttons { display: flex; flex-wrap: wrap; gap: 7px; }
.team-license-choice-buttons .btn { border-color: #d7dfe2; background: #fff; color: #202629; font-size: 10px; }
.team-license-choice-buttons .btn-primary { border-color: #f56600; background: #f56600; color: #fff; }
.team-license-choice-buttons .btn:hover { border-color: #f56600; color: #f56600; }
.team-license-choice-buttons .btn-primary:hover { background: #d95700; color: #fff; }
.team-license-submit { border: 1px solid #f56600; background: #f56600; color: #fff; font-size: 10px; }
.team-license-submit:hover { border-color: #d95700; background: #d95700; color: #fff; }
.team-license-legend { display: flex; flex-wrap: wrap; gap: 5px 10px; color: #687277; font-size: 10px; }
.team-license-legend span { display: inline-flex; align-items: center; gap: 4px; }
.team-license-status { width: 7px; height: 7px; border-radius: 50%; }
.team-license-status.expired { background: salmon; }
.team-license-status.expiring { background: #ffe066; }
.team-license-status.behind { background: #ff9a00; }
.team-license-eligibility { display: inline-block; padding: 2px 7px; border-radius: 999px; white-space: nowrap; }
.team-license-eligibility-renew { background: #fff0e5; color: #b64900; }
.team-license-eligibility-current { background: #e5e9eb; color: #59666d; }
.team-license-dialog .invalid,
.team-license-dialog .invalidSoon,
.team-license-dialog .team-license-before-team { display: inline-block; padding: 2px 6px; border-radius: 999px; color: #202629; }
.team-members-dialog { width: min(96vw, 820px); padding: 4px; color: #202629; }
.team-members-header { margin-bottom: 20px; padding: 20px; border-left: 4px solid #f56600; border-radius: 9px; background: #202629; color: #fff; }
.team-members-header h2 { margin: 0; font-size: 22px; font-weight: 700; }
.team-members-header p { margin: 5px 0 0; color: #c8d0d3; font-size: 11px; font-style: italic; }
.team-members-help { margin: 0 0 10px; color: #687277; font-size: 11px; }
.team-members-input { min-height: 150px; resize: vertical; }
.team-members-input:focus { border-color: #f56600; box-shadow: 0 0 0 .15rem rgba(245, 102, 0, .16); }
.team-members-actions { display: flex; flex-wrap: wrap; align-items: center; justify-content: space-between; gap: 8px; margin-top: 10px; }
.team-members-check { border: 1px solid #f56600; background: #f56600; color: #fff; font-size: 10px; }
.team-members-check:hover { border-color: #d95700; background: #d95700; color: #fff; }
.team-members-edit { border: 1px solid #d7dfe2; background: #fff; color: #202629; font-size: 10px; }
.team-members-edit:hover { border-color: #f56600; color: #f56600; }
.team-members-new-heading { margin-top: 18px; }
.team-members-empty { margin: 0; color: #687277; font-size: 11px; }
.team-members-dialog .team-members-table { width: 100%; min-width: 0; }
.team-members-submit-row { display: flex; justify-content: flex-end; margin-top: 14px; }
.team-members-submit { border: 1px solid #f56600; background: #f56600; color: #fff; font-size: 10px; }
.team-members-submit:hover { border-color: #d95700; background: #d95700; color: #fff; }
@media (max-width: 700px) { .team-license-dialog { width: calc(100vw - 24px); } .team-license-header { padding: 16px; } .team-license-actions { align-items: stretch; } .team-license-submit { width: 100%; } }
@media (max-width: 700px) { .team-members-dialog { width: calc(100vw - 24px); } .team-members-header { padding: 16px; } .team-members-submit { width: 100%; } }
@media (max-width: 700px) { .team-details { width: calc(100vw - 24px); } .team-details-header { padding: 16px; } }
.invalidSoon {
  background-color: yellow;
}
.invalid {
  background-color: salmon;
}
.team-license-before-team {
  background-color: orange;
}
.sim-brand-huntloc {
  background-color: #ff9a00;
  color: #111111;
  display: inline-block;
  padding: 1px 6px;
}
.sim-brand-doglo {
  background-color: #111111;
  color: #ffffff;
  display: inline-block;
  padding: 1px 6px;
}
.double-paid-team {
  color: #c62828;
  font-weight: bold;
}
.team-member-divider th {
  border-top: 2px solid #d7dbe1 !important;
}
.search {
  font-weight: bold;
  color: orangered;
}
.form-search {
  background-color: salmon;
  font-weight: bold;
}
.teams-data-table.hide-column-ownerName tr > :nth-child(2),
.teams-data-table.hide-column-phoneNumber tr > :nth-child(3),
.teams-data-table.hide-column-created_date tr > :nth-child(4),
.teams-data-table.hide-column-members tr > :nth-child(5),
.teams-data-table.hide-column-fullmembers tr > :nth-child(6),
.teams-data-table.hide-column-othermembers tr > :nth-child(7),
.teams-data-table.hide-column-licenceCount tr > :nth-child(8),
.teams-data-table.hide-column-validUntil tr > :nth-child(9),
.teams-data-table.hide-column-details tr > :nth-child(10) {
  display: none !important;
}
.teams-data-details-cell { text-align: center; }
/* clears the 'X' from Internet Explorer */
input[type="search"]::-ms-clear {
  display: none;
  width: 0;
  height: 0;
}
input[type="search"]::-ms-reveal {
  display: none;
  width: 0;
  height: 0;
}

/* clears the 'X' from Chrome */
input[type="search"]::-webkit-search-decoration,
input[type="search"]::-webkit-search-cancel-button,
input[type="search"]::-webkit-search-results-button,
input[type="search"]::-webkit-search-results-decoration {
  display: none;
}
.lds-ring {
  display: inline-block;
  position: relative;
  width: 80px;
  height: 80px;
}
.lds-ring div {
  box-sizing: border-box;
  display: block;
  position: absolute;
  width: 64px;
  height: 64px;
  margin: 8px;
  border: 8px solid #fff;
  border-radius: 50%;
  animation: lds-ring 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
  border-color: #000 transparent transparent transparent;
}
.lds-ring div:nth-child(1) {
  animation-delay: -0.45s;
}
.lds-ring div:nth-child(2) {
  animation-delay: -0.3s;
}
.lds-ring div:nth-child(3) {
  animation-delay: -0.15s;
}
.lds-ring-sm {
  display: inline-block;
  position: relative;
  width: 40px;
  height: 40px;
}
.lds-ring-sm div {
  box-sizing: border-box;
  display: block;
  position: absolute;
  width: 24px;
  height: 24px;
  border: 4px solid #fff;
  border-radius: 50%;
  animation: lds-ring 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
  border-color: #000 transparent transparent transparent;
}
.lds-ring-sm div:nth-child(1) {
  animation-delay: -0.45s;
}
.lds-ring-sm div:nth-child(2) {
  animation-delay: -0.3s;
}
.lds-ring-sm div:nth-child(3) {
  animation-delay: -0.15s;
}
.popper {
  margin-top: 10%;
}
.butt{
    font-size: 10px;
    font-weight: normal;
}
@keyframes lds-ring {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
@media screen and (max-width: 768px) {
}
</style>
